var map = {
	"./css/accordion.css": "c16b",
	"./css/authen.css": "adc3",
	"./css/bank-card.css": "2490",
	"./css/common_asset.css": "ba4c",
	"./css/footer.css": "46f5",
	"./css/gameiframe.css": "b018",
	"./css/index-login-full-screen.css": "e5a3",
	"./css/landing-page.css": "3313",
	"./css/main.css": "5aea",
	"./css/minor_css/proxy/bootstrap.min.css": "f341",
	"./css/minor_css/proxy/bootstrap.min.css.map": "b841",
	"./css/minor_css/proxy/proxy_style.css": "9269",
	"./css/my-mall.css": "9561",
	"./css/my_kyc.css": "8e8d",
	"./css/nav-login.css": "db7a",
	"./css/newLanding.css": "309b",
	"./css/popup.css": "c1b1",
	"./css/reset.css": "4ee2",
	"./css/style.css": "6672",
	"./css/support-new.css": "cb7c",
	"./css/useful_link.css": "cac3",
	"./css/verify-code-popup.css": "b0fa",
	"./css/vip.css": "b88a",
	"./theme_blue/images/9_gift.png": "aa87",
	"./theme_blue/images/Angle-left-g.png": "c08b",
	"./theme_blue/images/Angle-left.png": "193d",
	"./theme_blue/images/Angle-right-g.png": "2746",
	"./theme_blue/images/Angle-right.png": "59f2",
	"./theme_blue/images/BarbarianFury.png": "6b41",
	"./theme_blue/images/BattleDwarfXmas.png": "cd95",
	"./theme_blue/images/BoatBonanzaDownUnder.png": "9272",
	"./theme_blue/images/DragonKingHotPots.png": "607f",
	"./theme_blue/images/Ellipse.png": "7fed",
	"./theme_blue/images/H5_TOP.jpg": "21c0",
	"./theme_blue/images/HawaiianDreamXmas.png": "a11a",
	"./theme_blue/images/LogoLoading_circle01.png": "96ec",
	"./theme_blue/images/LogoLoading_circle02.png": "a16e",
	"./theme_blue/images/LogoLoading_katsu.png": "0d19",
	"./theme_blue/images/OiranDreamXmas.png": "bd80",
	"./theme_blue/images/PyramidRisingx33.png": "bcc2",
	"./theme_blue/images/RichWildeandtheTomeofInsanity.png": "20cd",
	"./theme_blue/images/SparkofGenius.png": "396b",
	"./theme_blue/images/Starstruck.png": "cae0",
	"./theme_blue/images/TheGoldenOwlofAthena.png": "bf21",
	"./theme_blue/images/TheSwordandtheGrailExcalibur.png": "d607",
	"./theme_blue/images/Withdraw-gold.svg": "1467",
	"./theme_blue/images/Withdraw-icon.svg": "208d",
	"./theme_blue/images/about_bg04.png": "53c3",
	"./theme_blue/images/add.svg": "eb9a",
	"./theme_blue/images/affiliates.png": "5df3",
	"./theme_blue/images/bankB-gold.svg": "3c48",
	"./theme_blue/images/bankB-icon.svg": "909d",
	"./theme_blue/images/bg-masthead-mb.png": "2ff6",
	"./theme_blue/images/bg-masthead.png": "0c74",
	"./theme_blue/images/bg_brush.png": "f344",
	"./theme_blue/images/bg_repeat.png": "71b4",
	"./theme_blue/images/bg_top.png": "0f0d",
	"./theme_blue/images/birth-bonus.png": "b3fc",
	"./theme_blue/images/bitcoin-btc-gold.svg": "3578",
	"./theme_blue/images/bitcoin-btc-logo.svg": "ca51",
	"./theme_blue/images/blog.png": "c9d8",
	"./theme_blue/images/bullhorn.svg": "4c46",
	"./theme_blue/images/cach-gold.svg": "e690",
	"./theme_blue/images/cach-icon.svg": "2c35",
	"./theme_blue/images/card-gold.svg": "fe01",
	"./theme_blue/images/card-icon.svg": "a000",
	"./theme_blue/images/ch_logo.png": "77a0",
	"./theme_blue/images/championship-bg.jpg": "2085",
	"./theme_blue/images/championship-main-event-bg.jpg": "b3c8",
	"./theme_blue/images/check-on.png": "adf9",
	"./theme_blue/images/cn_logo.png": "d399",
	"./theme_blue/images/collect.png": "e348",
	"./theme_blue/images/collect_full.png": "0ec9",
	"./theme_blue/images/comments-question.svg": "31f4",
	"./theme_blue/images/completed.png": "59c9",
	"./theme_blue/images/creditcard-back.png": "8015",
	"./theme_blue/images/creditcard-front.png": "0ade",
	"./theme_blue/images/crypto-ada.svg": "a787",
	"./theme_blue/images/crypto-bch.svg": "e33f",
	"./theme_blue/images/crypto-bnb.svg": "b84f",
	"./theme_blue/images/crypto-btc.svg": "9016",
	"./theme_blue/images/crypto-cny.svg": "2ac7",
	"./theme_blue/images/crypto-dai.svg": "9b0b",
	"./theme_blue/images/crypto-doge.svg": "767c",
	"./theme_blue/images/crypto-eos.svg": "d23c",
	"./theme_blue/images/crypto-eth.svg": "6694",
	"./theme_blue/images/crypto-jpy.svg": "6179",
	"./theme_blue/images/crypto-ltc.svg": "3eea",
	"./theme_blue/images/crypto-shib.svg": "7b79",
	"./theme_blue/images/crypto-teth.svg": "35c1",
	"./theme_blue/images/crypto-trx.svg": "9aeb",
	"./theme_blue/images/crypto-twd.svg": "2c1e",
	"./theme_blue/images/crypto-ubd.svg": "5bb8",
	"./theme_blue/images/crypto-usd.svg": "466f",
	"./theme_blue/images/crypto-usdc.svg": "a262",
	"./theme_blue/images/crypto-usdt.svg": "d541",
	"./theme_blue/images/crypto-xrp.svg": "1eff",
	"./theme_blue/images/daily-attend.png": "edf1",
	"./theme_blue/images/db_gift_left.png": "1c0e",
	"./theme_blue/images/db_gift_right.png": "fd3b",
	"./theme_blue/images/db_hero_img_mb.png": "f874",
	"./theme_blue/images/db_hero_img_pc.png": "7540",
	"./theme_blue/images/db_icon_coin.png": "60a1",
	"./theme_blue/images/db_icon_lock.png": "4c45",
	"./theme_blue/images/default-crypto.svg": "a945",
	"./theme_blue/images/deposit-gold.svg": "efe9",
	"./theme_blue/images/deposit-icon.svg": "cf92",
	"./theme_blue/images/dot-dk.svg": "ce77",
	"./theme_blue/images/dot-orange.svg": "7d63",
	"./theme_blue/images/dot.svg": "a2ba",
	"./theme_blue/images/dw.png": "99df",
	"./theme_blue/images/electron-gold.svg": "5c9a",
	"./theme_blue/images/electron-icon.svg": "5c32",
	"./theme_blue/images/email.svg": "a7ca",
	"./theme_blue/images/en_logo.png": "ed7b",
	"./theme_blue/images/event.png": "2ece",
	"./theme_blue/images/event_specail_deposit_bg3.png": "0e47",
	"./theme_blue/images/favorite.png": "ef5f",
	"./theme_blue/images/footer_gaming1.png": "d010",
	"./theme_blue/images/footer_gaming2.png": "78cb",
	"./theme_blue/images/footer_gaming3.png": "cf9d",
	"./theme_blue/images/footer_gaming4.png": "bc63",
	"./theme_blue/images/fortunewheel.png": "a8e4",
	"./theme_blue/images/friend_promo.png": "84e1",
	"./theme_blue/images/giftbox.png": "ee20",
	"./theme_blue/images/headset.png": "a4c9",
	"./theme_blue/images/heart-line.svg": "8212",
	"./theme_blue/images/heart.svg": "2729",
	"./theme_blue/images/history.png": "2ee9",
	"./theme_blue/images/home-arrow-left.png": "1265",
	"./theme_blue/images/home-arrow-right.png": "4f1b",
	"./theme_blue/images/icon-account.png": "dc1d",
	"./theme_blue/images/icon-add.png": "c94d",
	"./theme_blue/images/icon-alert-kyc.png": "e22b",
	"./theme_blue/images/icon-alert.png": "4676",
	"./theme_blue/images/icon-arrow-down-2.png": "04bb",
	"./theme_blue/images/icon-arrow-down-3.png": "a368",
	"./theme_blue/images/icon-arrow-down-4-disabled.png": "4d8f",
	"./theme_blue/images/icon-arrow-down-4.png": "49d4",
	"./theme_blue/images/icon-arrow-down-gold.png": "ecf8",
	"./theme_blue/images/icon-arrow-down.png": "0c03",
	"./theme_blue/images/icon-arrow-dropdown.png": "64a6",
	"./theme_blue/images/icon-arrow-right.png": "825b",
	"./theme_blue/images/icon-arrow-rightx2.png": "f434",
	"./theme_blue/images/icon-check-black.png": "3f19",
	"./theme_blue/images/icon-check.png": "3a3f",
	"./theme_blue/images/icon-checked.png": "ba39",
	"./theme_blue/images/icon-close-black.png": "c99a",
	"./theme_blue/images/icon-close.png": "6934",
	"./theme_blue/images/icon-close_index_phone.png": "7568",
	"./theme_blue/images/icon-copy-2.png": "b5ce",
	"./theme_blue/images/icon-copy.png": "c17c",
	"./theme_blue/images/icon-credit.png": "09ac",
	"./theme_blue/images/icon-crown.png": "a5d7",
	"./theme_blue/images/icon-date.png": "1d90",
	"./theme_blue/images/icon-detail.png": "6b4d",
	"./theme_blue/images/icon-diamond.png": "72dc",
	"./theme_blue/images/icon-download.png": "b4a7",
	"./theme_blue/images/icon-edit-dark.png": "6510",
	"./theme_blue/images/icon-edit-fill.png": "0755",
	"./theme_blue/images/icon-expand-w.png": "3d7b",
	"./theme_blue/images/icon-favorite-active.png": "41dc",
	"./theme_blue/images/icon-favorite.png": "d754",
	"./theme_blue/images/icon-filter.png": "81e9",
	"./theme_blue/images/icon-flag.png": "51b7",
	"./theme_blue/images/icon-game-search.png": "20f1",
	"./theme_blue/images/icon-home.png": "6779",
	"./theme_blue/images/icon-info.png": "4a80",
	"./theme_blue/images/icon-invite-bonus.png": "d48c",
	"./theme_blue/images/icon-invite-promo.png": "2707",
	"./theme_blue/images/icon-invite-weekly.png": "67b1",
	"./theme_blue/images/icon-kyc-add.png": "66f0",
	"./theme_blue/images/icon-kyc-close.png": "7c01",
	"./theme_blue/images/icon-kyc-open.png": "2732",
	"./theme_blue/images/icon-lock.png": "90c6",
	"./theme_blue/images/icon-member-active.png": "c2bf",
	"./theme_blue/images/icon-member.png": "f115",
	"./theme_blue/images/icon-nav-home.png": "1c34",
	"./theme_blue/images/icon-news-w.png": "3325",
	"./theme_blue/images/icon-notice.png": "2347",
	"./theme_blue/images/icon-password.png": "ef73",
	"./theme_blue/images/icon-phone-active.png": "8297",
	"./theme_blue/images/icon-phone.png": "b743",
	"./theme_blue/images/icon-qrcode.png": "21ef",
	"./theme_blue/images/icon-real-name.png": "b9d2",
	"./theme_blue/images/icon-recommend.png": "4fa8",
	"./theme_blue/images/icon-refresh.png": "74aa",
	"./theme_blue/images/icon-register-success.png": "2fc0",
	"./theme_blue/images/icon-search.png": "3fc0",
	"./theme_blue/images/icon-slot-select.png": "f370",
	"./theme_blue/images/icon-slot.png": "32fb",
	"./theme_blue/images/icon-top-arrow.svg": "6f03",
	"./theme_blue/images/icon-usdt.png": "f861",
	"./theme_blue/images/icon_alert.png": "9121",
	"./theme_blue/images/icon_allgames.png": "ad5d",
	"./theme_blue/images/icon_awesome_bitcoin.png": "a511",
	"./theme_blue/images/icon_bell.png": "19b8",
	"./theme_blue/images/icon_bonus.svg": "9595",
	"./theme_blue/images/icon_calendar_light.png": "5b0f",
	"./theme_blue/images/icon_card_light.png": "1478",
	"./theme_blue/images/icon_check_white.png": "0941",
	"./theme_blue/images/icon_close.png": "fbe6",
	"./theme_blue/images/icon_copy_regular.png": "4269",
	"./theme_blue/images/icon_copy_white.png": "334a",
	"./theme_blue/images/icon_download_white.png": "0705",
	"./theme_blue/images/icon_email.png": "acf9",
	"./theme_blue/images/icon_ig.png": "df04",
	"./theme_blue/images/icon_img_01.png": "cf2c",
	"./theme_blue/images/icon_img_03.png": "8549",
	"./theme_blue/images/icon_img_04.png": "05d0",
	"./theme_blue/images/icon_img_05.png": "659f",
	"./theme_blue/images/icon_img_06.png": "8cd0",
	"./theme_blue/images/icon_img_07.png": "094e",
	"./theme_blue/images/icon_img_08.png": "c4c4",
	"./theme_blue/images/icon_img_09.png": "d317",
	"./theme_blue/images/icon_img_10.png": "6dfe",
	"./theme_blue/images/icon_img_11.png": "112c",
	"./theme_blue/images/icon_img_12.png": "1576",
	"./theme_blue/images/icon_img_13.png": "3999",
	"./theme_blue/images/icon_img_14.png": "935e",
	"./theme_blue/images/icon_img_15.png": "a8c2",
	"./theme_blue/images/icon_japan.png": "65ce",
	"./theme_blue/images/icon_jpy.png": "d873",
	"./theme_blue/images/icon_jpy.svg": "a2bd",
	"./theme_blue/images/icon_lock_light.png": "aa19",
	"./theme_blue/images/icon_metro_credit_card.png": "85dd",
	"./theme_blue/images/icon_payment_bankomat.png": "a366",
	"./theme_blue/images/icon_promo_check.png": "c2b1",
	"./theme_blue/images/icon_promo_check_v2.png": "fd20",
	"./theme_blue/images/icon_shield_gray.png": "9bd1",
	"./theme_blue/images/icon_simple_electron.png": "7d0b",
	"./theme_blue/images/icon_tab_favorite.png": "326c",
	"./theme_blue/images/icon_trash.png": "e54c",
	"./theme_blue/images/icon_twitter.png": "921d",
	"./theme_blue/images/icon_uestion.svg": "1a9d",
	"./theme_blue/images/icon_usd.svg": "5ac4",
	"./theme_blue/images/icon_user_light.png": "42c8",
	"./theme_blue/images/icon_youtube.png": "9459",
	"./theme_blue/images/image-bank.png": "109c",
	"./theme_blue/images/image-upload.png": "0543",
	"./theme_blue/images/instruction.png": "0c13",
	"./theme_blue/images/iocn-trash-fill.png": "04c5",
	"./theme_blue/images/japan.png": "22ae",
	"./theme_blue/images/jp-yen.svg": "fe58",
	"./theme_blue/images/jp_logo.png": "6725",
	"./theme_blue/images/leave.png": "2f48",
	"./theme_blue/images/lights_m.png": "d980",
	"./theme_blue/images/live.png": "5c87",
	"./theme_blue/images/login-left-2.jpg": "abee",
	"./theme_blue/images/login-left.jpg": "8d17",
	"./theme_blue/images/login-left.png": "d4ed",
	"./theme_blue/images/login-logo-2-mb.jpg": "cae3",
	"./theme_blue/images/login-logo.jpg": "520a",
	"./theme_blue/images/logo-2.webp": "5321",
	"./theme_blue/images/logo.png": "bf11",
	"./theme_blue/images/logo_ft.png": "28f3",
	"./theme_blue/images/logo_katsuwin.png": "d68c",
	"./theme_blue/images/lpfv-pc-2000.png": "b0b3",
	"./theme_blue/images/lpfv-pc-3000.png": "4f1c",
	"./theme_blue/images/lpfv-pc-4000.png": "78f4",
	"./theme_blue/images/lpfv-pc-5000.png": "7afc",
	"./theme_blue/images/lpfv-pc.png": "33ff",
	"./theme_blue/images/lpfv-sp-2000.png": "bc7f",
	"./theme_blue/images/lpfv-sp-3000.png": "86b0",
	"./theme_blue/images/lpfv-sp-4000.png": "e92d",
	"./theme_blue/images/lpfv-sp-5000.png": "0870",
	"./theme_blue/images/lpfv-sp.png": "d985",
	"./theme_blue/images/main_bg.jpg": "ca58",
	"./theme_blue/images/mall-invite-image.png": "5a3e",
	"./theme_blue/images/mall-product-image.png": "e2e0",
	"./theme_blue/images/money_pop.png": "8240",
	"./theme_blue/images/monthly-bonus.png": "1818",
	"./theme_blue/images/monyback-gold.svg": "95f4",
	"./theme_blue/images/monyback-icon.svg": "e0a5",
	"./theme_blue/images/my-account.png": "0dd3",
	"./theme_blue/images/my_kyc_ex1.png": "94d5",
	"./theme_blue/images/my_kyc_ex2.webp": "133a",
	"./theme_blue/images/nav-bottom-deposit-active.png": "4355",
	"./theme_blue/images/nav-bottom-deposit.png": "4a9a",
	"./theme_blue/images/nav-bottom-game-active.png": "7616",
	"./theme_blue/images/nav-bottom-game.png": "fd6d",
	"./theme_blue/images/nav-bottom-home-active.png": "8d44",
	"./theme_blue/images/nav-bottom-home-mobile-index.png": "189f",
	"./theme_blue/images/nav-bottom-home.png": "27af",
	"./theme_blue/images/nav-bottom-my-active.png": "c6fc",
	"./theme_blue/images/nav-bottom-my.png": "faeb",
	"./theme_blue/images/nav-bottom-offers-active.png": "b963",
	"./theme_blue/images/nav-bottom-offers.png": "ad6b",
	"./theme_blue/images/nav-bottom-toggle.png": "28a4",
	"./theme_blue/images/new_guide.png": "43a0",
	"./theme_blue/images/no-data.png": "5dae",
	"./theme_blue/images/no.svg": "c843",
	"./theme_blue/images/oncasy_logo.png": "1325",
	"./theme_blue/images/pachislot.png": "2b62",
	"./theme_blue/images/personal_data_ad.png": "a949",
	"./theme_blue/images/program.png": "f2ee",
	"./theme_blue/images/rank-1st.png": "5aab",
	"./theme_blue/images/rank-2nd.png": "004d",
	"./theme_blue/images/rank-3rd.png": "583d",
	"./theme_blue/images/rebate-bonus.png": "ba7c",
	"./theme_blue/images/register-bg.jpg": "c6a6",
	"./theme_blue/images/register-logo-pc.jpg": "1238",
	"./theme_blue/images/register-logo.jpg": "9ca8",
	"./theme_blue/images/register-logo.png": "5e88",
	"./theme_blue/images/registration-2000.png": "cd8f",
	"./theme_blue/images/registration-3000.png": "32d2",
	"./theme_blue/images/registration-4000.png": "9752",
	"./theme_blue/images/registration-5000.png": "9466c",
	"./theme_blue/images/registration.png": "8d8b",
	"./theme_blue/images/shop.png": "c578",
	"./theme_blue/images/skill.png": "e472",
	"./theme_blue/images/slots.png": "07ce",
	"./theme_blue/images/spin_wheel_bg_lt.png": "8d72",
	"./theme_blue/images/spin_wheel_bg_rt.png": "72e0",
	"./theme_blue/images/stake-logo.png": "a7ad",
	"./theme_blue/images/structure01.png": "2e64",
	"./theme_blue/images/structure01.svg": "48dd",
	"./theme_blue/images/structure02.png": "9008",
	"./theme_blue/images/structure02.svg": "ef46",
	"./theme_blue/images/structure03.png": "f511",
	"./theme_blue/images/structure03.svg": "c1bd",
	"./theme_blue/images/sup/pc_banner_sup_faq_k.webp": "ae37",
	"./theme_blue/images/sup/sub_support_1.png": "32f6",
	"./theme_blue/images/sup/sub_support_2.png": "6a15",
	"./theme_blue/images/sup/sub_support_3.png": "5207",
	"./theme_blue/images/sup/sub_support_4.png": "b901",
	"./theme_blue/images/sup/sub_support_5.png": "4cee",
	"./theme_blue/images/sup/sub_support_6.png": "3816",
	"./theme_blue/images/sup/sub_support_7.png": "a182",
	"./theme_blue/images/sup/sub_support_8.png": "0cf7",
	"./theme_blue/images/sup/sub_support_9.png": "2bec",
	"./theme_blue/images/sup/sub_support_banner.png": "73d1",
	"./theme_blue/images/sup/sup-self-restraint_banner.jpg": "ddba",
	"./theme_blue/images/sup/sup_cardsetting_bank1.jpg": "b460",
	"./theme_blue/images/sup/sup_cardsetting_bank2.jpg": "fe1c",
	"./theme_blue/images/sup/sup_cardsetting_bank3.jpg": "2d55",
	"./theme_blue/images/sup/sup_cardsetting_bank4.jpg": "845a",
	"./theme_blue/images/sup/sup_cardsetting_banner.jpg": "f746",
	"./theme_blue/images/sup/sup_cardsetting_ewallet1.jpg": "3c86",
	"./theme_blue/images/sup/sup_cardsetting_ewallet2.jpg": "07c8",
	"./theme_blue/images/sup/sup_cardsetting_ewallet3.jpg": "ed1c",
	"./theme_blue/images/sup/sup_cardsetting_ewallet4.jpg": "b373",
	"./theme_blue/images/sup/sup_cardsetting_ewalleti2.jpg": "2969",
	"./theme_blue/images/sup/sup_cardsetting_ewalleti3.jpg": "4710",
	"./theme_blue/images/sup/sup_cardsetting_ewalletid1.jpg": "8d19",
	"./theme_blue/images/sup/sup_cardsetting_ewalletid4.jpg": "18c7",
	"./theme_blue/images/sup/sup_cardsetting_ewalletid5.jpg": "ff3a",
	"./theme_blue/images/sup/sup_deposit_bank1.jpg": "ae8f",
	"./theme_blue/images/sup/sup_deposit_bank2.jpg": "006f",
	"./theme_blue/images/sup/sup_deposit_bank3.jpg": "d1c6",
	"./theme_blue/images/sup/sup_deposit_bank_1.png": "8438",
	"./theme_blue/images/sup/sup_deposit_bank_2.png": "bcbb",
	"./theme_blue/images/sup/sup_deposit_bank_3.png": "f7a2",
	"./theme_blue/images/sup/sup_deposit_bank_4.png": "20a7",
	"./theme_blue/images/sup/sup_deposit_ccpayment1.jpg": "c4c3",
	"./theme_blue/images/sup/sup_deposit_ccpayment2.jpg": "2027",
	"./theme_blue/images/sup/sup_deposit_ccpayment3.jpg": "242b",
	"./theme_blue/images/sup/sup_deposit_crypto1.jpg": "c3e1",
	"./theme_blue/images/sup/sup_deposit_crypto10.jpg": "9804",
	"./theme_blue/images/sup/sup_deposit_crypto11.jpg": "125f",
	"./theme_blue/images/sup/sup_deposit_crypto12.jpg": "bceb",
	"./theme_blue/images/sup/sup_deposit_crypto2.jpg": "7403",
	"./theme_blue/images/sup/sup_deposit_crypto3.jpg": "f2a7",
	"./theme_blue/images/sup/sup_deposit_crypto4.jpg": "f757",
	"./theme_blue/images/sup/sup_deposit_crypto5.jpg": "0df7",
	"./theme_blue/images/sup/sup_deposit_crypto6.jpg": "041f",
	"./theme_blue/images/sup/sup_deposit_crypto7.jpg": "a53e",
	"./theme_blue/images/sup/sup_deposit_crypto8.jpg": "a79f",
	"./theme_blue/images/sup/sup_deposit_crypto9.jpg": "dbd6",
	"./theme_blue/images/sup/sup_deposit_jeten1.jpg": "28cc",
	"./theme_blue/images/sup/sup_deposit_jeten2.jpg": "09c9",
	"./theme_blue/images/sup/sup_deposit_jeten3.jpg": "12a5",
	"./theme_blue/images/sup/sup_deposit_mtpay1.jpg": "293e",
	"./theme_blue/images/sup/sup_deposit_mtpay2.jpg": "8d3c",
	"./theme_blue/images/sup/sup_deposit_mtpay3.jpg": "5036",
	"./theme_blue/images/sup/sup_deposit_vega1.jpg": "c2a8",
	"./theme_blue/images/sup/sup_deposit_vega2.jpg": "bc3e",
	"./theme_blue/images/sup/sup_deposit_vega3.jpg": "d6cf",
	"./theme_blue/images/sup/sup_deposit_vega4.jpg": "22f0",
	"./theme_blue/images/sup/sup_faq_banner.jpg": "a80f",
	"./theme_blue/images/sup/sup_kyc_1.jpg": "cad1",
	"./theme_blue/images/sup/sup_kyc_10.jpg": "2d54",
	"./theme_blue/images/sup/sup_kyc_11.jpg": "6934b",
	"./theme_blue/images/sup/sup_kyc_2.jpg": "6844",
	"./theme_blue/images/sup/sup_kyc_3.jpg": "9747",
	"./theme_blue/images/sup/sup_kyc_4.jpg": "7a353",
	"./theme_blue/images/sup/sup_kyc_5.jpg": "5cdf",
	"./theme_blue/images/sup/sup_kyc_6.jpg": "a8fa",
	"./theme_blue/images/sup/sup_kyc_7.jpg": "1750",
	"./theme_blue/images/sup/sup_kyc_8.jpg": "d432",
	"./theme_blue/images/sup/sup_kyc_9.jpg": "d84e",
	"./theme_blue/images/sup/sup_kyc_banner.jpg": "e3fd",
	"./theme_blue/images/sup/sup_login_1.png": "8d66",
	"./theme_blue/images/sup/sup_login_2.png": "3e70",
	"./theme_blue/images/sup/sup_login_3.png": "109c3",
	"./theme_blue/images/sup/sup_login_4.png": "1136",
	"./theme_blue/images/sup/sup_login_5.png": "5b44",
	"./theme_blue/images/sup/sup_login_6.png": "6d4e",
	"./theme_blue/images/sup/sup_login_7.png": "116a",
	"./theme_blue/images/sup/sup_login_banner.png": "b33d",
	"./theme_blue/images/sup/sup_payment_method_banner.jpg": "4eee",
	"./theme_blue/images/sup/sup_register_1.png": "3c9b",
	"./theme_blue/images/sup/sup_register_2.png": "2285",
	"./theme_blue/images/sup/sup_register_3.png": "20b3",
	"./theme_blue/images/sup/sup_register_4.png": "74ce",
	"./theme_blue/images/sup/sup_register_5.png": "372f",
	"./theme_blue/images/sup/sup_register_banner.png": "f458",
	"./theme_blue/images/sup/sup_vip_class_upgrading1.jpg": "cc65",
	"./theme_blue/images/sup/sup_vip_class_upgrading2.jpg": "82a6",
	"./theme_blue/images/sup/sup_vip_class_upgrading3.jpg": "b617",
	"./theme_blue/images/sup/sup_vip_class_upgrading4.jpg": "4c93",
	"./theme_blue/images/sup/sup_vip_class_upgrading_banner.jpg": "62b9",
	"./theme_blue/images/sup/sup_wallet_1.jpg": "b697",
	"./theme_blue/images/sup/sup_wallet_2.jpg": "7e8e",
	"./theme_blue/images/sup/sup_wallet_3.jpg": "ab3f",
	"./theme_blue/images/sup/sup_wallet_4.jpg": "6a83",
	"./theme_blue/images/sup/sup_wallet_5.jpg": "ee18",
	"./theme_blue/images/sup/sup_wallet_6.jpg": "94f9",
	"./theme_blue/images/sup/sup_wallet_banner.jpg": "f896",
	"./theme_blue/images/sup/sup_withdraw_bank1.jpg": "2100",
	"./theme_blue/images/sup/sup_withdraw_bank2.jpg": "d64d",
	"./theme_blue/images/sup/sup_withdraw_bank3.jpg": "791e",
	"./theme_blue/images/sup/sup_withdraw_crypto1.jpg": "3c37",
	"./theme_blue/images/sup/sup_withdraw_crypto2.jpg": "1b58",
	"./theme_blue/images/sup/sup_withdraw_crypto3.jpg": "2864",
	"./theme_blue/images/sup/sup_withdraw_crypto4.jpg": "50cf",
	"./theme_blue/images/sup/sup_withdraw_jeton1.jpg": "f2c8",
	"./theme_blue/images/sup/sup_withdraw_jeton2.jpg": "acf92",
	"./theme_blue/images/sup/sup_withdraw_jeton3.jpg": "4880",
	"./theme_blue/images/sup/sup_withdraw_mtpay1.jpg": "3a0b",
	"./theme_blue/images/sup/sup_withdraw_mtpay2.jpg": "1838",
	"./theme_blue/images/sup/sup_withdraw_mtpay3.jpg": "63a3",
	"./theme_blue/images/sup/sup_withdraw_vega1.jpg": "3609",
	"./theme_blue/images/sup/sup_withdraw_vega2.jpg": "f4bf",
	"./theme_blue/images/sup/sup_withdraw_vega3.jpg": "1f64",
	"./theme_blue/images/terms-bg.png": "b933",
	"./theme_blue/images/title-championship.png": "8b3d",
	"./theme_blue/images/top10-bn.png": "10d7",
	"./theme_blue/images/top10-bn2.png": "3baa",
	"./theme_blue/images/top_up.png": "52e6",
	"./theme_blue/images/trophy-gold.svg": "71cb",
	"./theme_blue/images/trophy-icon.svg": "2b4e",
	"./theme_blue/images/useful_link/agent_five.webp": "3caf",
	"./theme_blue/images/useful_link/agent_four.webp": "4ad9",
	"./theme_blue/images/useful_link/agent_one.webp": "d600",
	"./theme_blue/images/useful_link/agent_three.webp": "9e22",
	"./theme_blue/images/useful_link/agent_two.webp": "c29a",
	"./theme_blue/images/useful_link/agent_validSeal.webp": "b7bc",
	"./theme_blue/images/useful_link/bg.jpg": "9a5d",
	"./theme_blue/images/useful_link/bonusIntroducing.webp": "f166",
	"./theme_blue/images/useful_link/icon_FAQ.png": "af65",
	"./theme_blue/images/useful_link/icon_account_binding.png": "4516",
	"./theme_blue/images/useful_link/icon_confirm_method.png": "641e",
	"./theme_blue/images/useful_link/icon_coupon.png": "e093",
	"./theme_blue/images/useful_link/icon_deposit_withdraw.png": "cc7f",
	"./theme_blue/images/useful_link/icon_event_bonus.png": "8112",
	"./theme_blue/images/useful_link/icon_login.png": "0888",
	"./theme_blue/images/useful_link/icon_login_method.png": "0215",
	"./theme_blue/images/useful_link/icon_recommended_games.png": "bca9",
	"./theme_blue/images/useful_link/icon_self_restriction.png": "d7fc",
	"./theme_blue/images/useful_link/icon_shop.png": "1b36",
	"./theme_blue/images/useful_link/icon_vip_class_upgrading.png": "6369",
	"./theme_blue/images/useful_link/icon_wallet.png": "99af",
	"./theme_blue/images/useful_link/pc_banner_agent.jpeg": "b8d3",
	"./theme_blue/images/useful_link/pc_banner_cookie.jpeg": "7354",
	"./theme_blue/images/useful_link/pc_banner_cooperation.jpeg": "cea4",
	"./theme_blue/images/useful_link/pc_banner_cooperation.jpg": "f6d7",
	"./theme_blue/images/useful_link/pc_banner_privacy.jpeg": "0b17",
	"./theme_blue/images/useful_link/pc_banner_rule.jpeg": "5f99",
	"./theme_blue/images/useful_link/pc_banner_sport.jpeg": "3cd5",
	"./theme_blue/images/useful_link/pc_banner_support.jpeg": "df34",
	"./theme_blue/images/useful_link/pc_banner_support.png": "8e49",
	"./theme_blue/images/useful_link/pc_banner_terms.png": "1249",
	"./theme_blue/images/vector.svg": "c359",
	"./theme_blue/images/verify.png": "4a7c",
	"./theme_blue/images/vip-24-hours.png": "d4ed9",
	"./theme_blue/images/vip-arrow-left.png": "6872",
	"./theme_blue/images/vip-arrow-right.png": "bf03",
	"./theme_blue/images/vip-bg.jpg": "c44a",
	"./theme_blue/images/vip-bonus.png": "9062",
	"./theme_blue/images/vip-coin-stack.png": "d440",
	"./theme_blue/images/vip-crown.png": "bb7b",
	"./theme_blue/images/vip-green-line.png": "530e",
	"./theme_blue/images/vip-roulette.png": "6bd9",
	"./theme_blue/images/vip-wallet.png": "0977",
	"./theme_blue/images/vip.png": "f681",
	"./theme_blue/images/vip_bg.jpg": "8a65",
	"./theme_blue/images/vip_bg.png": "08bb",
	"./theme_blue/images/vip_gift_bg.png": "22b0",
	"./theme_blue/images/wallet.png": "f226",
	"./theme_blue/images/web_TOP.png": "411f",
	"./theme_blue/images/weekly-bonus.png": "3384",
	"./theme_blue/images/wheel_2x.png": "4530",
	"./theme_blue/variables.css": "78b0",
	"./theme_gold/images/9_gift.png": "c68c",
	"./theme_gold/images/Angle-left-g.png": "7294",
	"./theme_gold/images/Angle-left.png": "407c",
	"./theme_gold/images/Angle-right-g.png": "6363",
	"./theme_gold/images/Angle-right.png": "7040",
	"./theme_gold/images/BarbarianFury.png": "92a6",
	"./theme_gold/images/BattleDwarfXmas.png": "23b7",
	"./theme_gold/images/BoatBonanzaDownUnder.png": "9d98",
	"./theme_gold/images/DragonKingHotPots.png": "b099",
	"./theme_gold/images/Ellipse.png": "efd7",
	"./theme_gold/images/H5_TOP.jpg": "4ac0",
	"./theme_gold/images/HawaiianDreamXmas.png": "e196",
	"./theme_gold/images/LogoLoading_circle01.png": "8fe7",
	"./theme_gold/images/LogoLoading_circle02.png": "0b79",
	"./theme_gold/images/LogoLoading_katsu.png": "bf62",
	"./theme_gold/images/OiranDreamXmas.png": "6549",
	"./theme_gold/images/PyramidRisingx33.png": "1739",
	"./theme_gold/images/RichWildeandtheTomeofInsanity.png": "f06a",
	"./theme_gold/images/SparkofGenius.png": "0cc0",
	"./theme_gold/images/Starstruck.png": "7f34",
	"./theme_gold/images/TheGoldenOwlofAthena.png": "030e",
	"./theme_gold/images/TheSwordandtheGrailExcalibur.png": "bbeb",
	"./theme_gold/images/Withdraw-gold.svg": "171d",
	"./theme_gold/images/Withdraw-icon.svg": "4d29",
	"./theme_gold/images/about_bg04.png": "0ae5",
	"./theme_gold/images/add.svg": "00f8",
	"./theme_gold/images/affiliates.png": "027e",
	"./theme_gold/images/bankB-gold.svg": "a442",
	"./theme_gold/images/bankB-icon.svg": "1023",
	"./theme_gold/images/bg-masthead-mb.png": "3128",
	"./theme_gold/images/bg-masthead.png": "45df",
	"./theme_gold/images/bg_brush.png": "ad51",
	"./theme_gold/images/bg_repeat.png": "a63d",
	"./theme_gold/images/bg_top.png": "7453",
	"./theme_gold/images/birth-bonus.png": "ae80",
	"./theme_gold/images/bitcoin-btc-gold.svg": "2ece3",
	"./theme_gold/images/bitcoin-btc-logo.svg": "e7ed",
	"./theme_gold/images/blog.png": "bb49",
	"./theme_gold/images/bullhorn.svg": "1497",
	"./theme_gold/images/cach-gold.svg": "3d0e",
	"./theme_gold/images/cach-icon.svg": "70a4",
	"./theme_gold/images/card-gold.svg": "7597",
	"./theme_gold/images/card-icon.svg": "a316",
	"./theme_gold/images/ch_logo.png": "1f60",
	"./theme_gold/images/championship-bg.jpg": "6480",
	"./theme_gold/images/championship-main-event-bg.jpg": "0c0c",
	"./theme_gold/images/check-on.png": "aac5",
	"./theme_gold/images/cn_logo.png": "f391",
	"./theme_gold/images/collect.png": "987c",
	"./theme_gold/images/collect_full.png": "14c4",
	"./theme_gold/images/comments-question.svg": "a918",
	"./theme_gold/images/completed.png": "a921",
	"./theme_gold/images/creditcard-back.png": "f6ab",
	"./theme_gold/images/creditcard-front.png": "78c8",
	"./theme_gold/images/crypto-ada.svg": "f014",
	"./theme_gold/images/crypto-bch.svg": "604f",
	"./theme_gold/images/crypto-bnb.svg": "ea95",
	"./theme_gold/images/crypto-btc.svg": "8555",
	"./theme_gold/images/crypto-cny.svg": "31ff",
	"./theme_gold/images/crypto-dai.svg": "f1cc",
	"./theme_gold/images/crypto-doge.svg": "a829",
	"./theme_gold/images/crypto-eos.svg": "3f53",
	"./theme_gold/images/crypto-eth.svg": "0ecc",
	"./theme_gold/images/crypto-jpy.svg": "c760",
	"./theme_gold/images/crypto-ltc.svg": "3739",
	"./theme_gold/images/crypto-shib.svg": "9d9c",
	"./theme_gold/images/crypto-teth.svg": "d07c",
	"./theme_gold/images/crypto-trx.svg": "8e2c",
	"./theme_gold/images/crypto-twd.svg": "ea77",
	"./theme_gold/images/crypto-usd.svg": "3602",
	"./theme_gold/images/crypto-usdc.svg": "a711",
	"./theme_gold/images/crypto-usdt.svg": "6fb5",
	"./theme_gold/images/crypto-xrp.svg": "5d3f",
	"./theme_gold/images/daily-attend.png": "d3ab",
	"./theme_gold/images/db_gift_left.png": "d01c",
	"./theme_gold/images/db_gift_right.png": "5744",
	"./theme_gold/images/db_hero_img_mb.png": "c127",
	"./theme_gold/images/db_hero_img_pc.png": "104d",
	"./theme_gold/images/db_icon_coin.png": "5b5c",
	"./theme_gold/images/db_icon_lock.png": "4e5e",
	"./theme_gold/images/default-crypto.svg": "16ef",
	"./theme_gold/images/deposit-gold.svg": "60aa",
	"./theme_gold/images/deposit-icon.svg": "3c1b",
	"./theme_gold/images/dot-dk.svg": "94d4",
	"./theme_gold/images/dot-orange.svg": "ada5",
	"./theme_gold/images/dot.svg": "4f38",
	"./theme_gold/images/dw.png": "c1d3",
	"./theme_gold/images/electron-gold.svg": "f8a1",
	"./theme_gold/images/electron-icon.svg": "082a",
	"./theme_gold/images/email.svg": "b4d8",
	"./theme_gold/images/en_logo.png": "4d1a",
	"./theme_gold/images/event.png": "d8d7",
	"./theme_gold/images/event_specail_deposit_bg3.png": "462e",
	"./theme_gold/images/favorite.png": "f533",
	"./theme_gold/images/footer_gaming1.png": "2398",
	"./theme_gold/images/footer_gaming2.png": "8058",
	"./theme_gold/images/footer_gaming3.png": "890e",
	"./theme_gold/images/footer_gaming4.png": "18b2",
	"./theme_gold/images/fortunewheel.png": "c281",
	"./theme_gold/images/friend_promo.png": "f7ff",
	"./theme_gold/images/giftbox.png": "4db4",
	"./theme_gold/images/headset.png": "550d",
	"./theme_gold/images/heart-line.svg": "343e",
	"./theme_gold/images/heart.svg": "5fe9",
	"./theme_gold/images/history.png": "89d8",
	"./theme_gold/images/home-arrow-left.png": "914e",
	"./theme_gold/images/home-arrow-right.png": "4bb9",
	"./theme_gold/images/icon-account.png": "1dc5",
	"./theme_gold/images/icon-add.png": "dab3",
	"./theme_gold/images/icon-alert-kyc.png": "d9bc",
	"./theme_gold/images/icon-alert.png": "bc92",
	"./theme_gold/images/icon-arrow-down-2.png": "3e9b",
	"./theme_gold/images/icon-arrow-down-3.png": "a110",
	"./theme_gold/images/icon-arrow-down-4-disabled.png": "8a77",
	"./theme_gold/images/icon-arrow-down-4.png": "7b08",
	"./theme_gold/images/icon-arrow-down-gold.png": "ab44",
	"./theme_gold/images/icon-arrow-down.png": "b346",
	"./theme_gold/images/icon-arrow-dropdown.png": "d851",
	"./theme_gold/images/icon-arrow-right.png": "28fb",
	"./theme_gold/images/icon-arrow-rightx2.png": "dffd",
	"./theme_gold/images/icon-check-black.png": "bf96",
	"./theme_gold/images/icon-check.png": "cac4",
	"./theme_gold/images/icon-checked.png": "b407",
	"./theme_gold/images/icon-close-black.png": "ed52",
	"./theme_gold/images/icon-close.png": "4297",
	"./theme_gold/images/icon-close_index_phone.png": "b998",
	"./theme_gold/images/icon-copy-2.png": "9df4",
	"./theme_gold/images/icon-copy.png": "96f0",
	"./theme_gold/images/icon-credit.png": "93c0",
	"./theme_gold/images/icon-crown.png": "6cb3",
	"./theme_gold/images/icon-date.png": "1e05",
	"./theme_gold/images/icon-detail.png": "61c1",
	"./theme_gold/images/icon-diamond.png": "8292",
	"./theme_gold/images/icon-download.png": "5225",
	"./theme_gold/images/icon-edit-dark.png": "2296",
	"./theme_gold/images/icon-edit-fill.png": "5f84",
	"./theme_gold/images/icon-expand-w.png": "d1e6",
	"./theme_gold/images/icon-favorite-active.png": "6a1d",
	"./theme_gold/images/icon-favorite.png": "afeb",
	"./theme_gold/images/icon-filter.png": "b706",
	"./theme_gold/images/icon-flag.png": "3935",
	"./theme_gold/images/icon-game-search.png": "0bec",
	"./theme_gold/images/icon-home.png": "7304",
	"./theme_gold/images/icon-info.png": "13d5",
	"./theme_gold/images/icon-invite-bonus.png": "80151",
	"./theme_gold/images/icon-invite-promo.png": "aeda",
	"./theme_gold/images/icon-invite-weekly.png": "e0d4",
	"./theme_gold/images/icon-kyc-add.png": "814a",
	"./theme_gold/images/icon-kyc-close.png": "3f94",
	"./theme_gold/images/icon-kyc-open.png": "f957",
	"./theme_gold/images/icon-lock.png": "c9ed",
	"./theme_gold/images/icon-member-active.png": "5ee8",
	"./theme_gold/images/icon-member.png": "a63db",
	"./theme_gold/images/icon-nav-home.png": "0544",
	"./theme_gold/images/icon-news-w.png": "1d7b",
	"./theme_gold/images/icon-notice.png": "3323",
	"./theme_gold/images/icon-password.png": "5876",
	"./theme_gold/images/icon-phone-active.png": "3b9d",
	"./theme_gold/images/icon-phone.png": "c6fe",
	"./theme_gold/images/icon-qrcode.png": "b3df",
	"./theme_gold/images/icon-real-name.png": "bc12",
	"./theme_gold/images/icon-recommend.png": "01f3",
	"./theme_gold/images/icon-refresh.png": "6426",
	"./theme_gold/images/icon-register-success.png": "b335",
	"./theme_gold/images/icon-search.png": "735c",
	"./theme_gold/images/icon-slot-select.png": "d9bcc",
	"./theme_gold/images/icon-slot.png": "9e01",
	"./theme_gold/images/icon-top-arrow.svg": "f7c8",
	"./theme_gold/images/icon-usdt.png": "8ff3",
	"./theme_gold/images/icon_alert.png": "60a2",
	"./theme_gold/images/icon_allgames.png": "7079",
	"./theme_gold/images/icon_awesome_bitcoin.png": "bdb6",
	"./theme_gold/images/icon_bell.png": "9dd8",
	"./theme_gold/images/icon_bonus.svg": "2d74",
	"./theme_gold/images/icon_calendar_light.png": "e6bd",
	"./theme_gold/images/icon_card_light.png": "980f",
	"./theme_gold/images/icon_check_white.png": "ac67",
	"./theme_gold/images/icon_close.png": "7374",
	"./theme_gold/images/icon_copy_regular.png": "c28e",
	"./theme_gold/images/icon_copy_white.png": "428d",
	"./theme_gold/images/icon_download_white.png": "3ec2",
	"./theme_gold/images/icon_email.png": "becd",
	"./theme_gold/images/icon_ig.png": "d816",
	"./theme_gold/images/icon_img_01.png": "f154",
	"./theme_gold/images/icon_img_03.png": "0f71",
	"./theme_gold/images/icon_img_04.png": "ab60",
	"./theme_gold/images/icon_img_05.png": "cbeb",
	"./theme_gold/images/icon_img_06.png": "ecc1",
	"./theme_gold/images/icon_img_07.png": "74cc",
	"./theme_gold/images/icon_img_08.png": "abc5",
	"./theme_gold/images/icon_img_09.png": "93e2",
	"./theme_gold/images/icon_img_10.png": "620a",
	"./theme_gold/images/icon_img_11.png": "b86d",
	"./theme_gold/images/icon_img_12.png": "d245",
	"./theme_gold/images/icon_img_13.png": "aebc",
	"./theme_gold/images/icon_img_14.png": "c0f5",
	"./theme_gold/images/icon_img_15.png": "384f",
	"./theme_gold/images/icon_japan.png": "40fc",
	"./theme_gold/images/icon_jpy.png": "4674",
	"./theme_gold/images/icon_jpy.svg": "cd57",
	"./theme_gold/images/icon_lock_light.png": "8422",
	"./theme_gold/images/icon_metro_credit_card.png": "1727",
	"./theme_gold/images/icon_payment_bankomat.png": "ca5d",
	"./theme_gold/images/icon_promo_check.png": "1ee0",
	"./theme_gold/images/icon_promo_check_v2.png": "7b00",
	"./theme_gold/images/icon_shield_gray.png": "c7ef",
	"./theme_gold/images/icon_simple_electron.png": "00ec",
	"./theme_gold/images/icon_tab_favorite.png": "20a5",
	"./theme_gold/images/icon_trash.png": "9471",
	"./theme_gold/images/icon_twitter.png": "fe57",
	"./theme_gold/images/icon_uestion.svg": "4731",
	"./theme_gold/images/icon_usd.svg": "fbc8",
	"./theme_gold/images/icon_user_light.png": "e0f6",
	"./theme_gold/images/icon_youtube.png": "a7a4",
	"./theme_gold/images/image-bank.png": "3fdc",
	"./theme_gold/images/image-upload.png": "efe2",
	"./theme_gold/images/instruction.png": "2a26",
	"./theme_gold/images/iocn-trash-fill.png": "cb4a",
	"./theme_gold/images/japan.png": "3686",
	"./theme_gold/images/jp-yen.svg": "19ca",
	"./theme_gold/images/jp_logo.png": "930c",
	"./theme_gold/images/leave.png": "3876",
	"./theme_gold/images/lights_m.png": "bcac",
	"./theme_gold/images/live.png": "cf51",
	"./theme_gold/images/login-left-2.jpg": "95f1",
	"./theme_gold/images/login-left.jpg": "5ea3",
	"./theme_gold/images/login-left.png": "f4e9",
	"./theme_gold/images/login-logo-2-mb.jpg": "6628",
	"./theme_gold/images/login-logo.jpg": "caca",
	"./theme_gold/images/logo-2.webp": "25a0",
	"./theme_gold/images/logo.png": "bbcd",
	"./theme_gold/images/logo_ft.png": "d16c",
	"./theme_gold/images/logo_katsuwin.png": "c293",
	"./theme_gold/images/lpfv-pc-2000.png": "73b4",
	"./theme_gold/images/lpfv-pc-3000.png": "b437",
	"./theme_gold/images/lpfv-pc-4000.png": "6ed0",
	"./theme_gold/images/lpfv-pc-5000.png": "2f2f",
	"./theme_gold/images/lpfv-pc.png": "2e36",
	"./theme_gold/images/lpfv-sp-2000.png": "8a83",
	"./theme_gold/images/lpfv-sp-3000.png": "5a9e",
	"./theme_gold/images/lpfv-sp-4000.png": "9de3",
	"./theme_gold/images/lpfv-sp-5000.png": "b1db",
	"./theme_gold/images/lpfv-sp.png": "040e",
	"./theme_gold/images/main_bg.jpg": "9deb",
	"./theme_gold/images/mall-invite-image.png": "26be",
	"./theme_gold/images/mall-product-image.png": "d8be",
	"./theme_gold/images/money_pop.png": "b7b7",
	"./theme_gold/images/monthly-bonus.png": "88c4",
	"./theme_gold/images/monyback-gold.svg": "63c5",
	"./theme_gold/images/monyback-icon.svg": "1513",
	"./theme_gold/images/my-account.png": "88ef",
	"./theme_gold/images/my_kyc_ex1.png": "c235",
	"./theme_gold/images/my_kyc_ex2.webp": "aa91",
	"./theme_gold/images/nav-bottom-deposit-active.png": "5a42",
	"./theme_gold/images/nav-bottom-deposit.png": "bc5a",
	"./theme_gold/images/nav-bottom-game-active.png": "7561",
	"./theme_gold/images/nav-bottom-game.png": "3824",
	"./theme_gold/images/nav-bottom-home-active.png": "d640",
	"./theme_gold/images/nav-bottom-home-mobile-index.png": "fb75",
	"./theme_gold/images/nav-bottom-home.png": "65e1",
	"./theme_gold/images/nav-bottom-my-active.png": "65c9",
	"./theme_gold/images/nav-bottom-my.png": "c4fe",
	"./theme_gold/images/nav-bottom-offers-active.png": "3854",
	"./theme_gold/images/nav-bottom-offers.png": "47f5",
	"./theme_gold/images/nav-bottom-toggle.png": "c337",
	"./theme_gold/images/new_guide.png": "32ff",
	"./theme_gold/images/no-data.png": "9c8b",
	"./theme_gold/images/no.svg": "ef64",
	"./theme_gold/images/oncasy_logo.png": "55c9",
	"./theme_gold/images/pachislot.png": "54a9",
	"./theme_gold/images/personal_data_ad.png": "9c4e",
	"./theme_gold/images/program.png": "f10a",
	"./theme_gold/images/rank-1st.png": "05eb",
	"./theme_gold/images/rank-2nd.png": "8429",
	"./theme_gold/images/rank-3rd.png": "0128",
	"./theme_gold/images/rebate-bonus.png": "7dc9",
	"./theme_gold/images/register-bg.jpg": "dc80",
	"./theme_gold/images/register-logo-pc.jpg": "9db7",
	"./theme_gold/images/register-logo.jpg": "48f5",
	"./theme_gold/images/register-logo.png": "569a",
	"./theme_gold/images/registration-2000.png": "631e",
	"./theme_gold/images/registration-3000.png": "7728",
	"./theme_gold/images/registration-4000.png": "7530",
	"./theme_gold/images/registration-5000.png": "4f3e",
	"./theme_gold/images/registration.png": "7840",
	"./theme_gold/images/shop.png": "b51c",
	"./theme_gold/images/skill.png": "065d",
	"./theme_gold/images/slots.png": "da60",
	"./theme_gold/images/spin_wheel_bg_lt.png": "9952",
	"./theme_gold/images/spin_wheel_bg_rt.png": "cd50",
	"./theme_gold/images/stake-logo.png": "039f",
	"./theme_gold/images/structure01.png": "9d7b",
	"./theme_gold/images/structure01.svg": "e843",
	"./theme_gold/images/structure02.png": "ac4c",
	"./theme_gold/images/structure02.svg": "ccfc",
	"./theme_gold/images/structure03.png": "ad6a",
	"./theme_gold/images/structure03.svg": "767f",
	"./theme_gold/images/sup/pc_banner_sup_faq_k.webp": "5a98",
	"./theme_gold/images/sup/sub_support_1.png": "75c3",
	"./theme_gold/images/sup/sub_support_2.png": "27c0",
	"./theme_gold/images/sup/sub_support_3.png": "93bd",
	"./theme_gold/images/sup/sub_support_4.png": "0277",
	"./theme_gold/images/sup/sub_support_5.png": "4bc9",
	"./theme_gold/images/sup/sub_support_6.png": "88a3",
	"./theme_gold/images/sup/sub_support_7.png": "d4cd",
	"./theme_gold/images/sup/sub_support_8.png": "9980",
	"./theme_gold/images/sup/sub_support_9.png": "40c2",
	"./theme_gold/images/sup/sub_support_banner.png": "25f4",
	"./theme_gold/images/sup/sup-self-restraint_banner.jpg": "eccf",
	"./theme_gold/images/sup/sup_cardsetting_bank1.jpg": "cc99",
	"./theme_gold/images/sup/sup_cardsetting_bank2.jpg": "7ec7",
	"./theme_gold/images/sup/sup_cardsetting_bank3.jpg": "7cf4",
	"./theme_gold/images/sup/sup_cardsetting_bank4.jpg": "57c6",
	"./theme_gold/images/sup/sup_cardsetting_banner.jpg": "2009",
	"./theme_gold/images/sup/sup_cardsetting_ewallet1.jpg": "d4ef",
	"./theme_gold/images/sup/sup_cardsetting_ewallet2.jpg": "305e",
	"./theme_gold/images/sup/sup_cardsetting_ewallet3.jpg": "ebe5",
	"./theme_gold/images/sup/sup_cardsetting_ewallet4.jpg": "39eb",
	"./theme_gold/images/sup/sup_cardsetting_ewalleti2.jpg": "05b9",
	"./theme_gold/images/sup/sup_cardsetting_ewalleti3.jpg": "41ee",
	"./theme_gold/images/sup/sup_cardsetting_ewalletid1.jpg": "a371",
	"./theme_gold/images/sup/sup_cardsetting_ewalletid4.jpg": "68d5",
	"./theme_gold/images/sup/sup_cardsetting_ewalletid5.jpg": "2a20",
	"./theme_gold/images/sup/sup_deposit_bank1.jpg": "3814",
	"./theme_gold/images/sup/sup_deposit_bank2.jpg": "7db5",
	"./theme_gold/images/sup/sup_deposit_bank3.jpg": "eebb",
	"./theme_gold/images/sup/sup_deposit_bank_1.png": "f4da",
	"./theme_gold/images/sup/sup_deposit_bank_2.png": "8d69",
	"./theme_gold/images/sup/sup_deposit_bank_3.png": "effa",
	"./theme_gold/images/sup/sup_deposit_bank_4.png": "e8db",
	"./theme_gold/images/sup/sup_deposit_ccpayment1.jpg": "2252",
	"./theme_gold/images/sup/sup_deposit_ccpayment2.jpg": "228e",
	"./theme_gold/images/sup/sup_deposit_ccpayment3.jpg": "55a2",
	"./theme_gold/images/sup/sup_deposit_crypto1.jpg": "b07e",
	"./theme_gold/images/sup/sup_deposit_crypto10.jpg": "da45",
	"./theme_gold/images/sup/sup_deposit_crypto11.jpg": "73c2",
	"./theme_gold/images/sup/sup_deposit_crypto12.jpg": "d7b00",
	"./theme_gold/images/sup/sup_deposit_crypto2.jpg": "03e1",
	"./theme_gold/images/sup/sup_deposit_crypto3.jpg": "37c2",
	"./theme_gold/images/sup/sup_deposit_crypto4.jpg": "a4c0",
	"./theme_gold/images/sup/sup_deposit_crypto5.jpg": "2bdc",
	"./theme_gold/images/sup/sup_deposit_crypto6.jpg": "05f7",
	"./theme_gold/images/sup/sup_deposit_crypto7.jpg": "cc81",
	"./theme_gold/images/sup/sup_deposit_crypto8.jpg": "c270",
	"./theme_gold/images/sup/sup_deposit_crypto9.jpg": "8bcc",
	"./theme_gold/images/sup/sup_deposit_jeten1.jpg": "2122",
	"./theme_gold/images/sup/sup_deposit_jeten2.jpg": "db0c",
	"./theme_gold/images/sup/sup_deposit_jeten3.jpg": "1e51",
	"./theme_gold/images/sup/sup_deposit_mtpay1.jpg": "bc95",
	"./theme_gold/images/sup/sup_deposit_mtpay2.jpg": "579a",
	"./theme_gold/images/sup/sup_deposit_mtpay3.jpg": "e43e",
	"./theme_gold/images/sup/sup_deposit_vega1.jpg": "2954",
	"./theme_gold/images/sup/sup_deposit_vega2.jpg": "2128",
	"./theme_gold/images/sup/sup_deposit_vega3.jpg": "f1c2",
	"./theme_gold/images/sup/sup_deposit_vega4.jpg": "7949",
	"./theme_gold/images/sup/sup_faq_banner.jpg": "d83f",
	"./theme_gold/images/sup/sup_kyc_1.jpg": "18d5",
	"./theme_gold/images/sup/sup_kyc_10.jpg": "875a",
	"./theme_gold/images/sup/sup_kyc_11.jpg": "5051",
	"./theme_gold/images/sup/sup_kyc_2.jpg": "fd95",
	"./theme_gold/images/sup/sup_kyc_3.jpg": "479a",
	"./theme_gold/images/sup/sup_kyc_4.jpg": "d609",
	"./theme_gold/images/sup/sup_kyc_5.jpg": "95b1",
	"./theme_gold/images/sup/sup_kyc_6.jpg": "d77f",
	"./theme_gold/images/sup/sup_kyc_7.jpg": "b5ba",
	"./theme_gold/images/sup/sup_kyc_8.jpg": "fa82",
	"./theme_gold/images/sup/sup_kyc_9.jpg": "8dde",
	"./theme_gold/images/sup/sup_kyc_banner.jpg": "1182",
	"./theme_gold/images/sup/sup_login_1.png": "59df",
	"./theme_gold/images/sup/sup_login_2.png": "9c76",
	"./theme_gold/images/sup/sup_login_3.png": "ce16",
	"./theme_gold/images/sup/sup_login_4.png": "df1a",
	"./theme_gold/images/sup/sup_login_5.png": "ff6e",
	"./theme_gold/images/sup/sup_login_6.png": "081d",
	"./theme_gold/images/sup/sup_login_7.png": "09ee",
	"./theme_gold/images/sup/sup_login_banner.png": "c0ef",
	"./theme_gold/images/sup/sup_payment_method_banner.jpg": "81b3",
	"./theme_gold/images/sup/sup_register_1.png": "0745",
	"./theme_gold/images/sup/sup_register_2.png": "2ea4",
	"./theme_gold/images/sup/sup_register_3.png": "8944",
	"./theme_gold/images/sup/sup_register_4.png": "0aac",
	"./theme_gold/images/sup/sup_register_5.png": "8348",
	"./theme_gold/images/sup/sup_register_banner.png": "b301",
	"./theme_gold/images/sup/sup_vip_class_upgrading1.jpg": "a714",
	"./theme_gold/images/sup/sup_vip_class_upgrading2.jpg": "5306",
	"./theme_gold/images/sup/sup_vip_class_upgrading3.jpg": "2481",
	"./theme_gold/images/sup/sup_vip_class_upgrading4.jpg": "efcf",
	"./theme_gold/images/sup/sup_vip_class_upgrading_banner.jpg": "0497",
	"./theme_gold/images/sup/sup_wallet_1.jpg": "bf88",
	"./theme_gold/images/sup/sup_wallet_2.jpg": "291f",
	"./theme_gold/images/sup/sup_wallet_3.jpg": "f35a",
	"./theme_gold/images/sup/sup_wallet_4.jpg": "69d6",
	"./theme_gold/images/sup/sup_wallet_5.jpg": "9ada",
	"./theme_gold/images/sup/sup_wallet_6.jpg": "18b7",
	"./theme_gold/images/sup/sup_wallet_banner.jpg": "bddf",
	"./theme_gold/images/sup/sup_withdraw_bank1.jpg": "630f",
	"./theme_gold/images/sup/sup_withdraw_bank2.jpg": "3c59",
	"./theme_gold/images/sup/sup_withdraw_bank3.jpg": "e82d",
	"./theme_gold/images/sup/sup_withdraw_crypto1.jpg": "0cd7",
	"./theme_gold/images/sup/sup_withdraw_crypto2.jpg": "a4ec",
	"./theme_gold/images/sup/sup_withdraw_crypto3.jpg": "1f75",
	"./theme_gold/images/sup/sup_withdraw_crypto4.jpg": "33a6",
	"./theme_gold/images/sup/sup_withdraw_jeton1.jpg": "94ad",
	"./theme_gold/images/sup/sup_withdraw_jeton2.jpg": "6ad3",
	"./theme_gold/images/sup/sup_withdraw_jeton3.jpg": "0774",
	"./theme_gold/images/sup/sup_withdraw_mtpay1.jpg": "5885",
	"./theme_gold/images/sup/sup_withdraw_mtpay2.jpg": "aec2",
	"./theme_gold/images/sup/sup_withdraw_mtpay3.jpg": "b6c1",
	"./theme_gold/images/sup/sup_withdraw_vega1.jpg": "5bdf",
	"./theme_gold/images/sup/sup_withdraw_vega2.jpg": "c235d",
	"./theme_gold/images/sup/sup_withdraw_vega3.jpg": "9ae5",
	"./theme_gold/images/terms-bg.png": "fa81",
	"./theme_gold/images/title-championship.png": "579d",
	"./theme_gold/images/top10-bn.png": "c73d",
	"./theme_gold/images/top10-bn2.png": "273b",
	"./theme_gold/images/top_up.png": "20d1",
	"./theme_gold/images/trophy-gold.svg": "6d69",
	"./theme_gold/images/trophy-icon.svg": "257d",
	"./theme_gold/images/useful_link/agent_five.webp": "06a1",
	"./theme_gold/images/useful_link/agent_four.webp": "60b9",
	"./theme_gold/images/useful_link/agent_one.webp": "5fcc",
	"./theme_gold/images/useful_link/agent_three.webp": "b6ed",
	"./theme_gold/images/useful_link/agent_two.webp": "7dd3",
	"./theme_gold/images/useful_link/agent_validSeal.webp": "7f9e",
	"./theme_gold/images/useful_link/bg.jpg": "0a16",
	"./theme_gold/images/useful_link/bonusIntroducing.webp": "48b3",
	"./theme_gold/images/useful_link/icon_FAQ.png": "7cef",
	"./theme_gold/images/useful_link/icon_account_binding.png": "679f",
	"./theme_gold/images/useful_link/icon_confirm_method.png": "bfc0",
	"./theme_gold/images/useful_link/icon_coupon.png": "8f9f",
	"./theme_gold/images/useful_link/icon_deposit_withdraw.png": "6942",
	"./theme_gold/images/useful_link/icon_event_bonus.png": "9679",
	"./theme_gold/images/useful_link/icon_login.png": "5314",
	"./theme_gold/images/useful_link/icon_login_method.png": "b8c0",
	"./theme_gold/images/useful_link/icon_recommended_games.png": "8068",
	"./theme_gold/images/useful_link/icon_self_restriction.png": "cd56",
	"./theme_gold/images/useful_link/icon_shop.png": "089f",
	"./theme_gold/images/useful_link/icon_vip_class_upgrading.png": "13d8",
	"./theme_gold/images/useful_link/icon_wallet.png": "50f2",
	"./theme_gold/images/useful_link/pc_banner_agent.jpeg": "b993",
	"./theme_gold/images/useful_link/pc_banner_cookie.jpeg": "e535",
	"./theme_gold/images/useful_link/pc_banner_cooperation.jpeg": "e93e",
	"./theme_gold/images/useful_link/pc_banner_cooperation.jpg": "7647",
	"./theme_gold/images/useful_link/pc_banner_privacy.jpeg": "b597",
	"./theme_gold/images/useful_link/pc_banner_rule.jpeg": "0a61",
	"./theme_gold/images/useful_link/pc_banner_sport.jpeg": "91a1",
	"./theme_gold/images/useful_link/pc_banner_support.jpeg": "7cdc",
	"./theme_gold/images/useful_link/pc_banner_support.png": "2c56",
	"./theme_gold/images/useful_link/pc_banner_terms.png": "6782",
	"./theme_gold/images/vector.svg": "e980",
	"./theme_gold/images/verify.png": "8b0d",
	"./theme_gold/images/vip-24-hours.png": "2c23",
	"./theme_gold/images/vip-arrow-left.png": "48da",
	"./theme_gold/images/vip-arrow-right.png": "275d",
	"./theme_gold/images/vip-bg.jpg": "9c2b",
	"./theme_gold/images/vip-bonus.png": "fd24",
	"./theme_gold/images/vip-coin-stack.png": "33135",
	"./theme_gold/images/vip-crown.png": "265a",
	"./theme_gold/images/vip-green-line.png": "c6ff",
	"./theme_gold/images/vip-roulette.png": "3807",
	"./theme_gold/images/vip-wallet.png": "9cc2",
	"./theme_gold/images/vip.png": "ab9f",
	"./theme_gold/images/vip_bg.jpg": "f21c",
	"./theme_gold/images/vip_bg.png": "29c8",
	"./theme_gold/images/vip_gift_bg.png": "5e7b",
	"./theme_gold/images/wallet.png": "480d",
	"./theme_gold/images/web_TOP.png": "7399",
	"./theme_gold/images/weekly-bonus.png": "7c32",
	"./theme_gold/images/wheel_2x.png": "598a",
	"./theme_gold/variables.css": "822c",
	"./theme_purple/images/9_gift.png": "9620",
	"./theme_purple/images/Angle-left-g.png": "c35c",
	"./theme_purple/images/Angle-left.png": "8328",
	"./theme_purple/images/Angle-right-g.png": "bf76",
	"./theme_purple/images/Angle-right.png": "f48f",
	"./theme_purple/images/BarbarianFury.png": "47f2",
	"./theme_purple/images/BattleDwarfXmas.png": "28fe",
	"./theme_purple/images/BoatBonanzaDownUnder.png": "4b29",
	"./theme_purple/images/DragonKingHotPots.png": "5cca",
	"./theme_purple/images/Ellipse.png": "f122",
	"./theme_purple/images/H5_TOP.jpg": "cab4",
	"./theme_purple/images/HawaiianDreamXmas.png": "6894",
	"./theme_purple/images/LogoLoading_circle01.png": "9d88",
	"./theme_purple/images/LogoLoading_circle02.png": "fe3e",
	"./theme_purple/images/LogoLoading_katsu.png": "f518",
	"./theme_purple/images/OiranDreamXmas.png": "a0e9",
	"./theme_purple/images/PyramidRisingx33.png": "b92a",
	"./theme_purple/images/RichWildeandtheTomeofInsanity.png": "d365",
	"./theme_purple/images/SparkofGenius.png": "67a4",
	"./theme_purple/images/Starstruck.png": "727a",
	"./theme_purple/images/TheGoldenOwlofAthena.png": "6342",
	"./theme_purple/images/TheSwordandtheGrailExcalibur.png": "1b75",
	"./theme_purple/images/Withdraw-gold.svg": "6d90",
	"./theme_purple/images/Withdraw-icon.svg": "5e35",
	"./theme_purple/images/about_bg04.png": "a171",
	"./theme_purple/images/add.svg": "9851",
	"./theme_purple/images/affiliates.png": "a90a",
	"./theme_purple/images/bankB-gold.svg": "5f25",
	"./theme_purple/images/bankB-icon.svg": "e7b2",
	"./theme_purple/images/bg-masthead-mb.png": "768c",
	"./theme_purple/images/bg-masthead.png": "2764",
	"./theme_purple/images/bg_brush.png": "ff56",
	"./theme_purple/images/bg_repeat.png": "2121",
	"./theme_purple/images/bg_top.png": "e622",
	"./theme_purple/images/birth-bonus.png": "6768",
	"./theme_purple/images/bitcoin-btc-gold.svg": "91e1",
	"./theme_purple/images/bitcoin-btc-logo.svg": "8a60",
	"./theme_purple/images/blog.png": "ea59",
	"./theme_purple/images/bullhorn.svg": "cbe8",
	"./theme_purple/images/cach-gold.svg": "d280",
	"./theme_purple/images/cach-icon.svg": "d020",
	"./theme_purple/images/card-gold.svg": "b1e4",
	"./theme_purple/images/card-icon.svg": "fd19",
	"./theme_purple/images/ch_logo.png": "b1e7",
	"./theme_purple/images/championship-bg.jpg": "3935e",
	"./theme_purple/images/championship-main-event-bg.jpg": "69d7",
	"./theme_purple/images/check-on.png": "f436",
	"./theme_purple/images/cn_logo.png": "48f1",
	"./theme_purple/images/collect.png": "f563",
	"./theme_purple/images/collect_full.png": "a2de",
	"./theme_purple/images/comments-question.svg": "86b2",
	"./theme_purple/images/completed.png": "df87",
	"./theme_purple/images/creditcard-back.png": "5980",
	"./theme_purple/images/creditcard-front.png": "3913",
	"./theme_purple/images/crypto-ada.svg": "f98c",
	"./theme_purple/images/crypto-bch.svg": "714d",
	"./theme_purple/images/crypto-bnb.svg": "4585",
	"./theme_purple/images/crypto-btc.svg": "c23d",
	"./theme_purple/images/crypto-cny.svg": "f836",
	"./theme_purple/images/crypto-dai.svg": "7b8b",
	"./theme_purple/images/crypto-doge.svg": "11c5",
	"./theme_purple/images/crypto-eos.svg": "d6b8",
	"./theme_purple/images/crypto-eth.svg": "3a05",
	"./theme_purple/images/crypto-jpy.svg": "ac61",
	"./theme_purple/images/crypto-ltc.svg": "24ee",
	"./theme_purple/images/crypto-shib.svg": "eef2",
	"./theme_purple/images/crypto-teth.svg": "0cf0",
	"./theme_purple/images/crypto-trx.svg": "4965",
	"./theme_purple/images/crypto-twd.svg": "f2b0",
	"./theme_purple/images/crypto-usd.svg": "7198",
	"./theme_purple/images/crypto-usdc.svg": "1da6",
	"./theme_purple/images/crypto-usdt.svg": "f119",
	"./theme_purple/images/crypto-xrp.svg": "047c",
	"./theme_purple/images/daily-attend.png": "d9dd",
	"./theme_purple/images/db_gift_left.png": "6fe1",
	"./theme_purple/images/db_gift_right.png": "5179",
	"./theme_purple/images/db_hero_img_mb.png": "23d3",
	"./theme_purple/images/db_hero_img_pc.png": "b1c8",
	"./theme_purple/images/db_icon_coin.png": "6e39",
	"./theme_purple/images/db_icon_lock.png": "ce9c",
	"./theme_purple/images/default-crypto.svg": "f4f7",
	"./theme_purple/images/deposit-gold.svg": "83d5",
	"./theme_purple/images/deposit-icon.svg": "c43a",
	"./theme_purple/images/dot-dk.svg": "a37f",
	"./theme_purple/images/dot-orange.svg": "ef21",
	"./theme_purple/images/dot.svg": "7990",
	"./theme_purple/images/dw.png": "d5ae",
	"./theme_purple/images/electron-gold.svg": "c95d",
	"./theme_purple/images/electron-icon.svg": "ed69",
	"./theme_purple/images/email.svg": "dcc2",
	"./theme_purple/images/en_logo.png": "9c72",
	"./theme_purple/images/event.png": "3490",
	"./theme_purple/images/event_specail_deposit_bg3.png": "5e89",
	"./theme_purple/images/favorite.png": "85c1",
	"./theme_purple/images/footer_gaming1.png": "79ca",
	"./theme_purple/images/footer_gaming2.png": "ee8a",
	"./theme_purple/images/footer_gaming3.png": "fa7c",
	"./theme_purple/images/footer_gaming4.png": "1035",
	"./theme_purple/images/fortunewheel.png": "f0bd",
	"./theme_purple/images/friend_promo.png": "fcff",
	"./theme_purple/images/giftbox.png": "1fac",
	"./theme_purple/images/headset.png": "5850",
	"./theme_purple/images/heart-line.svg": "9bb3",
	"./theme_purple/images/heart.svg": "44c2",
	"./theme_purple/images/history.png": "d5a1",
	"./theme_purple/images/home-arrow-left.png": "5134",
	"./theme_purple/images/home-arrow-right.png": "217b",
	"./theme_purple/images/icon-account.png": "aac8",
	"./theme_purple/images/icon-add.png": "9e9f",
	"./theme_purple/images/icon-alert-kyc.png": "de6b",
	"./theme_purple/images/icon-alert.png": "87dd",
	"./theme_purple/images/icon-arrow-down-2.png": "08d6",
	"./theme_purple/images/icon-arrow-down-3.png": "2b49",
	"./theme_purple/images/icon-arrow-down-4-disabled.png": "e99e",
	"./theme_purple/images/icon-arrow-down-4.png": "5c27",
	"./theme_purple/images/icon-arrow-down-gold.png": "42ab",
	"./theme_purple/images/icon-arrow-down.png": "2706",
	"./theme_purple/images/icon-arrow-dropdown.png": "6006",
	"./theme_purple/images/icon-arrow-right.png": "a10c",
	"./theme_purple/images/icon-arrow-rightx2.png": "19a7",
	"./theme_purple/images/icon-check-black.png": "4352",
	"./theme_purple/images/icon-check.png": "d5bd",
	"./theme_purple/images/icon-checked.png": "74ab",
	"./theme_purple/images/icon-close-black.png": "adc2",
	"./theme_purple/images/icon-close.png": "cfc9",
	"./theme_purple/images/icon-close_index_phone.png": "cd99",
	"./theme_purple/images/icon-copy-2.png": "085e",
	"./theme_purple/images/icon-copy.png": "84ff",
	"./theme_purple/images/icon-credit.png": "898f",
	"./theme_purple/images/icon-crown.png": "486e",
	"./theme_purple/images/icon-date.png": "1d01",
	"./theme_purple/images/icon-detail.png": "ae08",
	"./theme_purple/images/icon-diamond.png": "6b55",
	"./theme_purple/images/icon-download.png": "fae2",
	"./theme_purple/images/icon-edit-dark.png": "303f",
	"./theme_purple/images/icon-edit-fill.png": "d07b",
	"./theme_purple/images/icon-expand-w.png": "0b92",
	"./theme_purple/images/icon-favorite-active.png": "2d24",
	"./theme_purple/images/icon-favorite.png": "1342",
	"./theme_purple/images/icon-filter.png": "cf86",
	"./theme_purple/images/icon-flag.png": "c6d9",
	"./theme_purple/images/icon-game-search.png": "4c57",
	"./theme_purple/images/icon-home.png": "6739",
	"./theme_purple/images/icon-info.png": "b870",
	"./theme_purple/images/icon-invite-bonus.png": "39cc",
	"./theme_purple/images/icon-invite-promo.png": "8035",
	"./theme_purple/images/icon-invite-weekly.png": "e296",
	"./theme_purple/images/icon-kyc-add.png": "52ad",
	"./theme_purple/images/icon-kyc-close.png": "384c",
	"./theme_purple/images/icon-kyc-open.png": "a632",
	"./theme_purple/images/icon-lock.png": "5158",
	"./theme_purple/images/icon-member-active.png": "d6cf4",
	"./theme_purple/images/icon-member.png": "16ac",
	"./theme_purple/images/icon-nav-home.png": "1fef",
	"./theme_purple/images/icon-news-w.png": "1094",
	"./theme_purple/images/icon-notice.png": "13ed",
	"./theme_purple/images/icon-password.png": "edb4",
	"./theme_purple/images/icon-phone-active.png": "ae68",
	"./theme_purple/images/icon-phone.png": "81f0",
	"./theme_purple/images/icon-qrcode.png": "b9c1",
	"./theme_purple/images/icon-real-name.png": "a361",
	"./theme_purple/images/icon-recommend.png": "8dd6",
	"./theme_purple/images/icon-refresh.png": "1c63",
	"./theme_purple/images/icon-register-success.png": "33af",
	"./theme_purple/images/icon-search.png": "bd39",
	"./theme_purple/images/icon-slot-select.png": "273d",
	"./theme_purple/images/icon-slot.png": "0eb5",
	"./theme_purple/images/icon-top-arrow.svg": "52e0",
	"./theme_purple/images/icon-usdt.png": "c5327",
	"./theme_purple/images/icon_alert.png": "24db",
	"./theme_purple/images/icon_allgames.png": "0f1d",
	"./theme_purple/images/icon_awesome_bitcoin.png": "81d8",
	"./theme_purple/images/icon_bell.png": "a4f1",
	"./theme_purple/images/icon_bonus.svg": "a044",
	"./theme_purple/images/icon_calendar_light.png": "fdf1",
	"./theme_purple/images/icon_card_light.png": "205e",
	"./theme_purple/images/icon_check_white.png": "d480",
	"./theme_purple/images/icon_close.png": "e4d1",
	"./theme_purple/images/icon_copy_regular.png": "8868",
	"./theme_purple/images/icon_copy_white.png": "f60a",
	"./theme_purple/images/icon_download_white.png": "2013",
	"./theme_purple/images/icon_email.png": "0ed8",
	"./theme_purple/images/icon_ig.png": "1100",
	"./theme_purple/images/icon_img_01.png": "9b6c",
	"./theme_purple/images/icon_img_03.png": "dbf3",
	"./theme_purple/images/icon_img_04.png": "8a78",
	"./theme_purple/images/icon_img_05.png": "5dbd",
	"./theme_purple/images/icon_img_06.png": "a059",
	"./theme_purple/images/icon_img_07.png": "b78b",
	"./theme_purple/images/icon_img_08.png": "d310",
	"./theme_purple/images/icon_img_09.png": "c21c",
	"./theme_purple/images/icon_img_10.png": "28db",
	"./theme_purple/images/icon_img_11.png": "5f47",
	"./theme_purple/images/icon_img_12.png": "2740",
	"./theme_purple/images/icon_img_13.png": "4a03",
	"./theme_purple/images/icon_img_14.png": "1ee3",
	"./theme_purple/images/icon_img_15.png": "c9c1",
	"./theme_purple/images/icon_japan.png": "658a",
	"./theme_purple/images/icon_jpy.png": "1b7e",
	"./theme_purple/images/icon_jpy.svg": "900e",
	"./theme_purple/images/icon_lock_light.png": "2bfb",
	"./theme_purple/images/icon_metro_credit_card.png": "4c33",
	"./theme_purple/images/icon_payment_bankomat.png": "d5b2",
	"./theme_purple/images/icon_promo_check.png": "8eb5",
	"./theme_purple/images/icon_promo_check_v2.png": "fd46",
	"./theme_purple/images/icon_shield_gray.png": "d67a",
	"./theme_purple/images/icon_simple_electron.png": "0a8f",
	"./theme_purple/images/icon_tab_favorite.png": "406b",
	"./theme_purple/images/icon_trash.png": "6081",
	"./theme_purple/images/icon_twitter.png": "4457",
	"./theme_purple/images/icon_uestion.svg": "edc0",
	"./theme_purple/images/icon_usd.svg": "97ce",
	"./theme_purple/images/icon_user_light.png": "7a32",
	"./theme_purple/images/icon_youtube.png": "f8c0",
	"./theme_purple/images/image-bank.png": "9215",
	"./theme_purple/images/image-upload.png": "00de",
	"./theme_purple/images/instruction.png": "598d",
	"./theme_purple/images/iocn-trash-fill.png": "77f7",
	"./theme_purple/images/japan.png": "4335",
	"./theme_purple/images/jp-yen.svg": "076f",
	"./theme_purple/images/jp_logo.png": "5fef",
	"./theme_purple/images/leave.png": "c05f",
	"./theme_purple/images/lights_m.png": "1fd4",
	"./theme_purple/images/live.png": "8d8a",
	"./theme_purple/images/login-left-2.jpg": "6633",
	"./theme_purple/images/login-left.jpg": "a384",
	"./theme_purple/images/login-left.png": "b6f2",
	"./theme_purple/images/login-logo-2-mb.jpg": "a1d1",
	"./theme_purple/images/login-logo.jpg": "0015",
	"./theme_purple/images/logo-2.webp": "d4fc",
	"./theme_purple/images/logo.png": "7995",
	"./theme_purple/images/logo_ft.png": "aa9d",
	"./theme_purple/images/logo_katsuwin.png": "3177",
	"./theme_purple/images/lpfv-pc-2000.png": "c238",
	"./theme_purple/images/lpfv-pc-3000.png": "83e0",
	"./theme_purple/images/lpfv-pc-4000.png": "dc0e",
	"./theme_purple/images/lpfv-pc-5000.png": "8d661",
	"./theme_purple/images/lpfv-pc.png": "4028",
	"./theme_purple/images/lpfv-sp-2000.png": "cece",
	"./theme_purple/images/lpfv-sp-3000.png": "46eb",
	"./theme_purple/images/lpfv-sp-4000.png": "b372",
	"./theme_purple/images/lpfv-sp-5000.png": "aae3",
	"./theme_purple/images/lpfv-sp.png": "b135",
	"./theme_purple/images/main_bg.jpg": "99a9",
	"./theme_purple/images/mall-invite-image.png": "28e8",
	"./theme_purple/images/mall-product-image.png": "c053",
	"./theme_purple/images/money_pop.png": "8d29",
	"./theme_purple/images/monthly-bonus.png": "c48d",
	"./theme_purple/images/monyback-gold.svg": "82bf",
	"./theme_purple/images/monyback-icon.svg": "fa4e",
	"./theme_purple/images/my-account.png": "6325",
	"./theme_purple/images/my_kyc_ex1.png": "e9ce",
	"./theme_purple/images/my_kyc_ex2.webp": "4c70",
	"./theme_purple/images/nav-bottom-deposit-active.png": "d203",
	"./theme_purple/images/nav-bottom-deposit.png": "367e",
	"./theme_purple/images/nav-bottom-game-active.png": "a605",
	"./theme_purple/images/nav-bottom-game.png": "1c57",
	"./theme_purple/images/nav-bottom-home-active.png": "d8519",
	"./theme_purple/images/nav-bottom-home-mobile-index.png": "c31d",
	"./theme_purple/images/nav-bottom-home.png": "2e73",
	"./theme_purple/images/nav-bottom-my-active.png": "187c",
	"./theme_purple/images/nav-bottom-my.png": "2bbd",
	"./theme_purple/images/nav-bottom-offers-active.png": "53bc",
	"./theme_purple/images/nav-bottom-offers.png": "ceeb",
	"./theme_purple/images/nav-bottom-toggle.png": "126d",
	"./theme_purple/images/new_guide.png": "a2d6",
	"./theme_purple/images/no-data.png": "058e",
	"./theme_purple/images/no.svg": "325f",
	"./theme_purple/images/oncasy_logo.png": "b491",
	"./theme_purple/images/pachislot.png": "1b57",
	"./theme_purple/images/personal_data_ad.png": "8b50",
	"./theme_purple/images/program.png": "264a",
	"./theme_purple/images/rank-1st.png": "537d",
	"./theme_purple/images/rank-2nd.png": "e9bc",
	"./theme_purple/images/rank-3rd.png": "5e43",
	"./theme_purple/images/rebate-bonus.png": "a1f0",
	"./theme_purple/images/register-bg.jpg": "4b10",
	"./theme_purple/images/register-logo-pc.jpg": "6eaf",
	"./theme_purple/images/register-logo.jpg": "159b",
	"./theme_purple/images/register-logo.png": "4ce8",
	"./theme_purple/images/registration-2000.png": "6cdf",
	"./theme_purple/images/registration-3000.png": "f967",
	"./theme_purple/images/registration-4000.png": "301b",
	"./theme_purple/images/registration-5000.png": "4db3",
	"./theme_purple/images/registration.png": "5ff4",
	"./theme_purple/images/shop.png": "6d8f",
	"./theme_purple/images/skill.png": "87b5",
	"./theme_purple/images/slots.png": "e986",
	"./theme_purple/images/spin_wheel_bg_lt.png": "e33d",
	"./theme_purple/images/spin_wheel_bg_rt.png": "4864",
	"./theme_purple/images/stake-logo.png": "1229",
	"./theme_purple/images/structure01.png": "0b04",
	"./theme_purple/images/structure01.svg": "44a4",
	"./theme_purple/images/structure02.png": "ae46",
	"./theme_purple/images/structure02.svg": "cc7b",
	"./theme_purple/images/structure03.png": "c641",
	"./theme_purple/images/structure03.svg": "0687",
	"./theme_purple/images/sup/pc_banner_sup_faq_k.webp": "c2387",
	"./theme_purple/images/sup/sub_support_1.png": "84c7",
	"./theme_purple/images/sup/sub_support_2.png": "7497",
	"./theme_purple/images/sup/sub_support_3.png": "e435",
	"./theme_purple/images/sup/sub_support_4.png": "9381",
	"./theme_purple/images/sup/sub_support_5.png": "0d2f",
	"./theme_purple/images/sup/sub_support_6.png": "d1fc",
	"./theme_purple/images/sup/sub_support_7.png": "a52b",
	"./theme_purple/images/sup/sub_support_8.png": "031b",
	"./theme_purple/images/sup/sub_support_9.png": "b28d",
	"./theme_purple/images/sup/sub_support_banner.png": "e541",
	"./theme_purple/images/sup/sup-self-restraint_banner.jpg": "e91b",
	"./theme_purple/images/sup/sup_cardsetting_bank1.jpg": "7b5c",
	"./theme_purple/images/sup/sup_cardsetting_bank2.jpg": "1aa7",
	"./theme_purple/images/sup/sup_cardsetting_bank3.jpg": "0bf2",
	"./theme_purple/images/sup/sup_cardsetting_bank4.jpg": "7963",
	"./theme_purple/images/sup/sup_cardsetting_banner.jpg": "6656",
	"./theme_purple/images/sup/sup_cardsetting_ewallet1.jpg": "4447",
	"./theme_purple/images/sup/sup_cardsetting_ewallet2.jpg": "f307",
	"./theme_purple/images/sup/sup_cardsetting_ewallet3.jpg": "4030",
	"./theme_purple/images/sup/sup_cardsetting_ewallet4.jpg": "b90b",
	"./theme_purple/images/sup/sup_cardsetting_ewalleti2.jpg": "b638",
	"./theme_purple/images/sup/sup_cardsetting_ewalleti3.jpg": "9a1c",
	"./theme_purple/images/sup/sup_cardsetting_ewalletid1.jpg": "11b2",
	"./theme_purple/images/sup/sup_cardsetting_ewalletid4.jpg": "17e0",
	"./theme_purple/images/sup/sup_cardsetting_ewalletid5.jpg": "8f88",
	"./theme_purple/images/sup/sup_deposit_bank1.jpg": "e9af",
	"./theme_purple/images/sup/sup_deposit_bank2.jpg": "26a0",
	"./theme_purple/images/sup/sup_deposit_bank3.jpg": "8839",
	"./theme_purple/images/sup/sup_deposit_bank_1.png": "8eae",
	"./theme_purple/images/sup/sup_deposit_bank_2.png": "9296",
	"./theme_purple/images/sup/sup_deposit_bank_3.png": "fb25",
	"./theme_purple/images/sup/sup_deposit_bank_4.png": "7bdd",
	"./theme_purple/images/sup/sup_deposit_ccpayment1.jpg": "28e4",
	"./theme_purple/images/sup/sup_deposit_ccpayment2.jpg": "6684",
	"./theme_purple/images/sup/sup_deposit_ccpayment3.jpg": "4db8",
	"./theme_purple/images/sup/sup_deposit_crypto1.jpg": "5c7f",
	"./theme_purple/images/sup/sup_deposit_crypto10.jpg": "fda1",
	"./theme_purple/images/sup/sup_deposit_crypto11.jpg": "8565",
	"./theme_purple/images/sup/sup_deposit_crypto12.jpg": "066f",
	"./theme_purple/images/sup/sup_deposit_crypto2.jpg": "c62f",
	"./theme_purple/images/sup/sup_deposit_crypto3.jpg": "1221",
	"./theme_purple/images/sup/sup_deposit_crypto4.jpg": "0650",
	"./theme_purple/images/sup/sup_deposit_crypto5.jpg": "192b",
	"./theme_purple/images/sup/sup_deposit_crypto6.jpg": "c771",
	"./theme_purple/images/sup/sup_deposit_crypto7.jpg": "5ec7",
	"./theme_purple/images/sup/sup_deposit_crypto8.jpg": "04f9",
	"./theme_purple/images/sup/sup_deposit_crypto9.jpg": "0d04",
	"./theme_purple/images/sup/sup_deposit_jeten1.jpg": "ba1b",
	"./theme_purple/images/sup/sup_deposit_jeten2.jpg": "3f1e",
	"./theme_purple/images/sup/sup_deposit_jeten3.jpg": "c006",
	"./theme_purple/images/sup/sup_deposit_mtpay1.jpg": "6af0",
	"./theme_purple/images/sup/sup_deposit_mtpay2.jpg": "ec56",
	"./theme_purple/images/sup/sup_deposit_mtpay3.jpg": "c93c",
	"./theme_purple/images/sup/sup_deposit_vega1.jpg": "c478",
	"./theme_purple/images/sup/sup_deposit_vega2.jpg": "5100",
	"./theme_purple/images/sup/sup_deposit_vega3.jpg": "bd70",
	"./theme_purple/images/sup/sup_deposit_vega4.jpg": "ecdb",
	"./theme_purple/images/sup/sup_faq_banner.jpg": "69f4",
	"./theme_purple/images/sup/sup_kyc_1.jpg": "57d9",
	"./theme_purple/images/sup/sup_kyc_10.jpg": "5d83",
	"./theme_purple/images/sup/sup_kyc_11.jpg": "fa5c",
	"./theme_purple/images/sup/sup_kyc_2.jpg": "3467",
	"./theme_purple/images/sup/sup_kyc_3.jpg": "ca77",
	"./theme_purple/images/sup/sup_kyc_4.jpg": "1551",
	"./theme_purple/images/sup/sup_kyc_5.jpg": "35c0",
	"./theme_purple/images/sup/sup_kyc_6.jpg": "5ddc",
	"./theme_purple/images/sup/sup_kyc_7.jpg": "d0be",
	"./theme_purple/images/sup/sup_kyc_8.jpg": "fbd5",
	"./theme_purple/images/sup/sup_kyc_9.jpg": "6d18",
	"./theme_purple/images/sup/sup_kyc_banner.jpg": "5bff",
	"./theme_purple/images/sup/sup_login_1.png": "c970",
	"./theme_purple/images/sup/sup_login_2.png": "1d59",
	"./theme_purple/images/sup/sup_login_3.png": "a5de",
	"./theme_purple/images/sup/sup_login_4.png": "3dba",
	"./theme_purple/images/sup/sup_login_5.png": "7b5b",
	"./theme_purple/images/sup/sup_login_6.png": "8237",
	"./theme_purple/images/sup/sup_login_7.png": "cf16",
	"./theme_purple/images/sup/sup_login_banner.png": "1bef",
	"./theme_purple/images/sup/sup_payment_method_banner.jpg": "b74e",
	"./theme_purple/images/sup/sup_register_1.png": "e4cd",
	"./theme_purple/images/sup/sup_register_2.png": "6bd6",
	"./theme_purple/images/sup/sup_register_3.png": "bc1d",
	"./theme_purple/images/sup/sup_register_4.png": "d36f",
	"./theme_purple/images/sup/sup_register_5.png": "f022",
	"./theme_purple/images/sup/sup_register_banner.png": "76d7",
	"./theme_purple/images/sup/sup_vip_class_upgrading1.jpg": "66b3",
	"./theme_purple/images/sup/sup_vip_class_upgrading2.jpg": "f770",
	"./theme_purple/images/sup/sup_vip_class_upgrading3.jpg": "275e",
	"./theme_purple/images/sup/sup_vip_class_upgrading4.jpg": "56b5",
	"./theme_purple/images/sup/sup_vip_class_upgrading_banner.jpg": "463b",
	"./theme_purple/images/sup/sup_wallet_1.jpg": "6f15",
	"./theme_purple/images/sup/sup_wallet_2.jpg": "01f9",
	"./theme_purple/images/sup/sup_wallet_3.jpg": "cd53",
	"./theme_purple/images/sup/sup_wallet_4.jpg": "1def",
	"./theme_purple/images/sup/sup_wallet_5.jpg": "738b",
	"./theme_purple/images/sup/sup_wallet_6.jpg": "11c3",
	"./theme_purple/images/sup/sup_wallet_banner.jpg": "f0aa",
	"./theme_purple/images/sup/sup_withdraw_bank1.jpg": "f9ab",
	"./theme_purple/images/sup/sup_withdraw_bank2.jpg": "8f6e",
	"./theme_purple/images/sup/sup_withdraw_bank3.jpg": "1e0e",
	"./theme_purple/images/sup/sup_withdraw_crypto1.jpg": "46f4",
	"./theme_purple/images/sup/sup_withdraw_crypto2.jpg": "bf56",
	"./theme_purple/images/sup/sup_withdraw_crypto3.jpg": "b256",
	"./theme_purple/images/sup/sup_withdraw_crypto4.jpg": "e367",
	"./theme_purple/images/sup/sup_withdraw_jeton1.jpg": "9458",
	"./theme_purple/images/sup/sup_withdraw_jeton2.jpg": "4eb2",
	"./theme_purple/images/sup/sup_withdraw_jeton3.jpg": "73aa",
	"./theme_purple/images/sup/sup_withdraw_mtpay1.jpg": "107e",
	"./theme_purple/images/sup/sup_withdraw_mtpay2.jpg": "521c",
	"./theme_purple/images/sup/sup_withdraw_mtpay3.jpg": "02b1",
	"./theme_purple/images/sup/sup_withdraw_vega1.jpg": "fd468",
	"./theme_purple/images/sup/sup_withdraw_vega2.jpg": "f9b3",
	"./theme_purple/images/sup/sup_withdraw_vega3.jpg": "777b",
	"./theme_purple/images/terms-bg.png": "45eb",
	"./theme_purple/images/title-championship.png": "10c9",
	"./theme_purple/images/top10-bn.png": "5ba3",
	"./theme_purple/images/top10-bn2.png": "fd14",
	"./theme_purple/images/top_up.png": "1d04",
	"./theme_purple/images/trophy-gold.svg": "0e2a",
	"./theme_purple/images/trophy-icon.svg": "7690",
	"./theme_purple/images/useful_link/agent_five.webp": "8391",
	"./theme_purple/images/useful_link/agent_four.webp": "1db4",
	"./theme_purple/images/useful_link/agent_one.webp": "6e90",
	"./theme_purple/images/useful_link/agent_three.webp": "2e5f",
	"./theme_purple/images/useful_link/agent_two.webp": "b517",
	"./theme_purple/images/useful_link/agent_validSeal.webp": "292d",
	"./theme_purple/images/useful_link/bg.jpg": "b044",
	"./theme_purple/images/useful_link/bonusIntroducing.webp": "893f",
	"./theme_purple/images/useful_link/icon_FAQ.png": "a6a5",
	"./theme_purple/images/useful_link/icon_account_binding.png": "bc9c",
	"./theme_purple/images/useful_link/icon_confirm_method.png": "2e00",
	"./theme_purple/images/useful_link/icon_coupon.png": "a984",
	"./theme_purple/images/useful_link/icon_deposit_withdraw.png": "b37d",
	"./theme_purple/images/useful_link/icon_event_bonus.png": "5026",
	"./theme_purple/images/useful_link/icon_login.png": "c73f",
	"./theme_purple/images/useful_link/icon_login_method.png": "a00d",
	"./theme_purple/images/useful_link/icon_recommended_games.png": "fb6d",
	"./theme_purple/images/useful_link/icon_self_restriction.png": "159d",
	"./theme_purple/images/useful_link/icon_shop.png": "d53a",
	"./theme_purple/images/useful_link/icon_vip_class_upgrading.png": "abc8",
	"./theme_purple/images/useful_link/icon_wallet.png": "f65d",
	"./theme_purple/images/useful_link/pc_banner_agent.jpeg": "a143",
	"./theme_purple/images/useful_link/pc_banner_cookie.jpeg": "dad2",
	"./theme_purple/images/useful_link/pc_banner_cooperation.jpeg": "72eb",
	"./theme_purple/images/useful_link/pc_banner_cooperation.jpg": "f460",
	"./theme_purple/images/useful_link/pc_banner_privacy.jpeg": "0ce1",
	"./theme_purple/images/useful_link/pc_banner_rule.jpeg": "91d3",
	"./theme_purple/images/useful_link/pc_banner_sport.jpeg": "3832",
	"./theme_purple/images/useful_link/pc_banner_support.jpeg": "5256",
	"./theme_purple/images/useful_link/pc_banner_support.png": "27c1",
	"./theme_purple/images/useful_link/pc_banner_terms.png": "f383",
	"./theme_purple/images/vector.svg": "6085",
	"./theme_purple/images/verify.png": "ea40",
	"./theme_purple/images/vip-24-hours.png": "4224",
	"./theme_purple/images/vip-arrow-left.png": "cc53",
	"./theme_purple/images/vip-arrow-right.png": "ffff",
	"./theme_purple/images/vip-bg.jpg": "1fad",
	"./theme_purple/images/vip-bonus.png": "f823",
	"./theme_purple/images/vip-coin-stack.png": "73d8",
	"./theme_purple/images/vip-crown.png": "52e8",
	"./theme_purple/images/vip-green-line.png": "617d",
	"./theme_purple/images/vip-roulette.png": "12da",
	"./theme_purple/images/vip-wallet.png": "70bd",
	"./theme_purple/images/vip.png": "7440",
	"./theme_purple/images/vip_bg.jpg": "41a3",
	"./theme_purple/images/vip_bg.png": "3049",
	"./theme_purple/images/vip_gift_bg.png": "ff7f",
	"./theme_purple/images/wallet.png": "e2dd",
	"./theme_purple/images/web_TOP.png": "b278",
	"./theme_purple/images/weekly-bonus.png": "e01d",
	"./theme_purple/images/wheel_2x.png": "1ab2",
	"./theme_purple/variables.css": "4ba6",
	"./theme_royalgold/images/9_gift.png": "00bf",
	"./theme_royalgold/images/Angle-left-g.png": "871b",
	"./theme_royalgold/images/Angle-left.png": "c961",
	"./theme_royalgold/images/Angle-right-g.png": "5b8b",
	"./theme_royalgold/images/Angle-right.png": "932a",
	"./theme_royalgold/images/BarbarianFury.png": "dfba",
	"./theme_royalgold/images/BattleDwarfXmas.png": "ee47",
	"./theme_royalgold/images/BoatBonanzaDownUnder.png": "cfc2",
	"./theme_royalgold/images/DragonKingHotPots.png": "c909",
	"./theme_royalgold/images/Ellipse.png": "3ce4",
	"./theme_royalgold/images/H5_TOP.jpg": "3b70",
	"./theme_royalgold/images/HawaiianDreamXmas.png": "386c",
	"./theme_royalgold/images/LogoLoading_circle01.png": "8d8e",
	"./theme_royalgold/images/LogoLoading_circle02.png": "a3bc",
	"./theme_royalgold/images/LogoLoading_katsu.png": "554f",
	"./theme_royalgold/images/OiranDreamXmas.png": "6c5d",
	"./theme_royalgold/images/PyramidRisingx33.png": "3ac5",
	"./theme_royalgold/images/RichWildeandtheTomeofInsanity.png": "3482",
	"./theme_royalgold/images/SparkofGenius.png": "1f22",
	"./theme_royalgold/images/Starstruck.png": "cca2",
	"./theme_royalgold/images/TheGoldenOwlofAthena.png": "19e2",
	"./theme_royalgold/images/TheSwordandtheGrailExcalibur.png": "77dd",
	"./theme_royalgold/images/Withdraw-gold.svg": "3252",
	"./theme_royalgold/images/Withdraw-icon.svg": "a0f9",
	"./theme_royalgold/images/about_bg04.png": "ae2e",
	"./theme_royalgold/images/add.svg": "1246",
	"./theme_royalgold/images/affiliates.png": "cc5d",
	"./theme_royalgold/images/bankB-gold.svg": "d6a3",
	"./theme_royalgold/images/bankB-icon.svg": "2c45",
	"./theme_royalgold/images/bg-masthead-mb.png": "e59b",
	"./theme_royalgold/images/bg-masthead.png": "2bf2",
	"./theme_royalgold/images/bg_brush.png": "ffd5",
	"./theme_royalgold/images/bg_repeat.png": "0e0a",
	"./theme_royalgold/images/bg_top.png": "f14f",
	"./theme_royalgold/images/birth-bonus.png": "6509",
	"./theme_royalgold/images/bitcoin-btc-gold.svg": "a728",
	"./theme_royalgold/images/bitcoin-btc-logo.svg": "84e5",
	"./theme_royalgold/images/blog.png": "8291",
	"./theme_royalgold/images/bullhorn.svg": "0164",
	"./theme_royalgold/images/cach-gold.svg": "3b05",
	"./theme_royalgold/images/cach-icon.svg": "1bde",
	"./theme_royalgold/images/card-gold.svg": "ad9b",
	"./theme_royalgold/images/card-icon.svg": "e606",
	"./theme_royalgold/images/ch_logo.png": "0c38",
	"./theme_royalgold/images/championship-bg.jpg": "aa0a",
	"./theme_royalgold/images/championship-main-event-bg.jpg": "ed31",
	"./theme_royalgold/images/check-on.png": "3dc0",
	"./theme_royalgold/images/cn_logo.png": "e123",
	"./theme_royalgold/images/collect.png": "0c71",
	"./theme_royalgold/images/collect_full.png": "9a61",
	"./theme_royalgold/images/comments-question.svg": "0973",
	"./theme_royalgold/images/completed.png": "4bab",
	"./theme_royalgold/images/creditcard-back.png": "4042",
	"./theme_royalgold/images/creditcard-front.png": "75c8",
	"./theme_royalgold/images/crypto-ada.svg": "f1f9",
	"./theme_royalgold/images/crypto-bch.svg": "c390",
	"./theme_royalgold/images/crypto-bnb.svg": "b33a",
	"./theme_royalgold/images/crypto-btc.svg": "5fac",
	"./theme_royalgold/images/crypto-cny.svg": "02cd",
	"./theme_royalgold/images/crypto-dai.svg": "5f11",
	"./theme_royalgold/images/crypto-doge.svg": "7f52",
	"./theme_royalgold/images/crypto-eos.svg": "7931",
	"./theme_royalgold/images/crypto-eth.svg": "c9e6",
	"./theme_royalgold/images/crypto-jpy.svg": "0965",
	"./theme_royalgold/images/crypto-ltc.svg": "2ca3",
	"./theme_royalgold/images/crypto-shib.svg": "945f",
	"./theme_royalgold/images/crypto-teth.svg": "c0d1",
	"./theme_royalgold/images/crypto-trx.svg": "5df0",
	"./theme_royalgold/images/crypto-twd.svg": "2343",
	"./theme_royalgold/images/crypto-usd.svg": "a813",
	"./theme_royalgold/images/crypto-usdc.svg": "7bfa",
	"./theme_royalgold/images/crypto-usdt.svg": "233b",
	"./theme_royalgold/images/crypto-xrp.svg": "ead8",
	"./theme_royalgold/images/daily-attend.png": "53fc",
	"./theme_royalgold/images/db_gift_left.png": "09ff",
	"./theme_royalgold/images/db_gift_right.png": "9ddf",
	"./theme_royalgold/images/db_hero_img_mb.png": "7f29",
	"./theme_royalgold/images/db_hero_img_pc.png": "e4d8",
	"./theme_royalgold/images/db_icon_coin.png": "0f26",
	"./theme_royalgold/images/db_icon_lock.png": "c636",
	"./theme_royalgold/images/default-crypto.svg": "13a2",
	"./theme_royalgold/images/deposit-gold.svg": "c1e5",
	"./theme_royalgold/images/deposit-icon.svg": "dc91",
	"./theme_royalgold/images/dot-dk.svg": "0398",
	"./theme_royalgold/images/dot-orange.svg": "c721",
	"./theme_royalgold/images/dot.svg": "02ca",
	"./theme_royalgold/images/dw.png": "da34",
	"./theme_royalgold/images/electron-gold.svg": "713e",
	"./theme_royalgold/images/electron-icon.svg": "164c",
	"./theme_royalgold/images/email.svg": "8829",
	"./theme_royalgold/images/en_logo.png": "f364",
	"./theme_royalgold/images/event.png": "b508",
	"./theme_royalgold/images/event_specail_deposit_bg3.png": "36c3",
	"./theme_royalgold/images/favorite.png": "653d",
	"./theme_royalgold/images/footer_gaming1.png": "e97e",
	"./theme_royalgold/images/footer_gaming2.png": "1137",
	"./theme_royalgold/images/footer_gaming3.png": "6c3d",
	"./theme_royalgold/images/footer_gaming4.png": "08df",
	"./theme_royalgold/images/fortunewheel.png": "4d85",
	"./theme_royalgold/images/friend_promo.png": "cb63",
	"./theme_royalgold/images/giftbox.png": "b0ac",
	"./theme_royalgold/images/headset.png": "5ddc6",
	"./theme_royalgold/images/heart-line.svg": "ca93",
	"./theme_royalgold/images/heart.svg": "a96d",
	"./theme_royalgold/images/history.png": "42de",
	"./theme_royalgold/images/home-arrow-left.png": "7a35c",
	"./theme_royalgold/images/home-arrow-right.png": "aaff",
	"./theme_royalgold/images/icon-account.png": "832c",
	"./theme_royalgold/images/icon-add.png": "c1c8",
	"./theme_royalgold/images/icon-alert-kyc.png": "dc08",
	"./theme_royalgold/images/icon-alert.png": "a595",
	"./theme_royalgold/images/icon-arrow-down-2.png": "6d55",
	"./theme_royalgold/images/icon-arrow-down-3.png": "b492",
	"./theme_royalgold/images/icon-arrow-down-4-disabled.png": "0fbc",
	"./theme_royalgold/images/icon-arrow-down-4.png": "2fe6",
	"./theme_royalgold/images/icon-arrow-down-gold.png": "1508",
	"./theme_royalgold/images/icon-arrow-down.png": "a775",
	"./theme_royalgold/images/icon-arrow-dropdown.png": "6cc8",
	"./theme_royalgold/images/icon-arrow-right.png": "af05",
	"./theme_royalgold/images/icon-arrow-rightx2.png": "1742",
	"./theme_royalgold/images/icon-check-black.png": "e61c",
	"./theme_royalgold/images/icon-check.png": "abe7",
	"./theme_royalgold/images/icon-checked.png": "2033",
	"./theme_royalgold/images/icon-close-black.png": "f735",
	"./theme_royalgold/images/icon-close.png": "962a",
	"./theme_royalgold/images/icon-close_index_phone.png": "c4fc",
	"./theme_royalgold/images/icon-copy-2.png": "504c",
	"./theme_royalgold/images/icon-copy.png": "060c",
	"./theme_royalgold/images/icon-credit.png": "bd5f",
	"./theme_royalgold/images/icon-crown.png": "d7c6",
	"./theme_royalgold/images/icon-date.png": "abb7",
	"./theme_royalgold/images/icon-detail.png": "e68e",
	"./theme_royalgold/images/icon-diamond.png": "2fbb",
	"./theme_royalgold/images/icon-download.png": "231f",
	"./theme_royalgold/images/icon-edit-dark.png": "9a03",
	"./theme_royalgold/images/icon-edit-fill.png": "c444",
	"./theme_royalgold/images/icon-expand-w.png": "f4a8",
	"./theme_royalgold/images/icon-favorite-active.png": "1e33",
	"./theme_royalgold/images/icon-favorite.png": "57cf",
	"./theme_royalgold/images/icon-filter.png": "3cbe",
	"./theme_royalgold/images/icon-flag.png": "4709",
	"./theme_royalgold/images/icon-game-search.png": "398b",
	"./theme_royalgold/images/icon-home.png": "79b1",
	"./theme_royalgold/images/icon-info.png": "d065",
	"./theme_royalgold/images/icon-invite-bonus.png": "c9d0",
	"./theme_royalgold/images/icon-invite-promo.png": "bbb1",
	"./theme_royalgold/images/icon-invite-weekly.png": "eee0",
	"./theme_royalgold/images/icon-kyc-add.png": "4d56",
	"./theme_royalgold/images/icon-kyc-close.png": "655a",
	"./theme_royalgold/images/icon-kyc-open.png": "fcdb",
	"./theme_royalgold/images/icon-lock.png": "73ec",
	"./theme_royalgold/images/icon-member-active.png": "8a22",
	"./theme_royalgold/images/icon-member.png": "3776",
	"./theme_royalgold/images/icon-nav-home.png": "3031",
	"./theme_royalgold/images/icon-news-w.png": "925d",
	"./theme_royalgold/images/icon-notice.png": "389d",
	"./theme_royalgold/images/icon-password.png": "4795",
	"./theme_royalgold/images/icon-phone-active.png": "46d9",
	"./theme_royalgold/images/icon-phone.png": "eda2",
	"./theme_royalgold/images/icon-qrcode.png": "0e76",
	"./theme_royalgold/images/icon-real-name.png": "f7cd",
	"./theme_royalgold/images/icon-recommend.png": "49e9",
	"./theme_royalgold/images/icon-refresh.png": "3ffd",
	"./theme_royalgold/images/icon-register-success.png": "929e",
	"./theme_royalgold/images/icon-search.png": "0031",
	"./theme_royalgold/images/icon-slot-select.png": "fc4f",
	"./theme_royalgold/images/icon-slot.png": "b526",
	"./theme_royalgold/images/icon-top-arrow.svg": "6890",
	"./theme_royalgold/images/icon-usdt.png": "cd5c",
	"./theme_royalgold/images/icon_alert.png": "4385",
	"./theme_royalgold/images/icon_allgames.png": "7722",
	"./theme_royalgold/images/icon_awesome_bitcoin.png": "d335",
	"./theme_royalgold/images/icon_bell.png": "cb6b",
	"./theme_royalgold/images/icon_bonus.svg": "9150",
	"./theme_royalgold/images/icon_calendar_light.png": "6668",
	"./theme_royalgold/images/icon_card_light.png": "bea9",
	"./theme_royalgold/images/icon_check_white.png": "b51f",
	"./theme_royalgold/images/icon_close.png": "a24e",
	"./theme_royalgold/images/icon_copy_regular.png": "f75a",
	"./theme_royalgold/images/icon_copy_white.png": "670a",
	"./theme_royalgold/images/icon_download_white.png": "1eb2",
	"./theme_royalgold/images/icon_email.png": "7192",
	"./theme_royalgold/images/icon_ig.png": "d4e8",
	"./theme_royalgold/images/icon_img_01.png": "ff1f",
	"./theme_royalgold/images/icon_img_03.png": "cbc5",
	"./theme_royalgold/images/icon_img_04.png": "8487",
	"./theme_royalgold/images/icon_img_05.png": "be4c",
	"./theme_royalgold/images/icon_img_06.png": "bf63",
	"./theme_royalgold/images/icon_img_07.png": "21f2",
	"./theme_royalgold/images/icon_img_08.png": "a3ad",
	"./theme_royalgold/images/icon_img_09.png": "5042",
	"./theme_royalgold/images/icon_img_10.png": "3423",
	"./theme_royalgold/images/icon_img_11.png": "8d6f",
	"./theme_royalgold/images/icon_img_12.png": "9fcb",
	"./theme_royalgold/images/icon_img_13.png": "1d79",
	"./theme_royalgold/images/icon_img_14.png": "25c9",
	"./theme_royalgold/images/icon_img_15.png": "24a5",
	"./theme_royalgold/images/icon_japan.png": "ac78",
	"./theme_royalgold/images/icon_jpy.png": "8856",
	"./theme_royalgold/images/icon_jpy.svg": "ab97",
	"./theme_royalgold/images/icon_lock_light.png": "8cb1",
	"./theme_royalgold/images/icon_metro_credit_card.png": "c673",
	"./theme_royalgold/images/icon_payment_bankomat.png": "b16f",
	"./theme_royalgold/images/icon_promo_check.png": "31f7",
	"./theme_royalgold/images/icon_promo_check_v2.png": "a5b0",
	"./theme_royalgold/images/icon_shield_gray.png": "0131",
	"./theme_royalgold/images/icon_simple_electron.png": "dfe5",
	"./theme_royalgold/images/icon_tab_favorite.png": "6e57",
	"./theme_royalgold/images/icon_trash.png": "e10a",
	"./theme_royalgold/images/icon_twitter.png": "060d",
	"./theme_royalgold/images/icon_uestion.svg": "a1e9",
	"./theme_royalgold/images/icon_usd.svg": "5f55",
	"./theme_royalgold/images/icon_user_light.png": "ba08",
	"./theme_royalgold/images/icon_youtube.png": "5eae",
	"./theme_royalgold/images/image-bank.png": "0345",
	"./theme_royalgold/images/image-upload.png": "9fd6",
	"./theme_royalgold/images/instruction.png": "1be6",
	"./theme_royalgold/images/iocn-trash-fill.png": "b767",
	"./theme_royalgold/images/japan.png": "9466",
	"./theme_royalgold/images/jp-yen.svg": "c15f",
	"./theme_royalgold/images/jp_logo.png": "5911",
	"./theme_royalgold/images/leave.png": "1186",
	"./theme_royalgold/images/lights_m.png": "b5bf",
	"./theme_royalgold/images/live.png": "7013",
	"./theme_royalgold/images/login-left-2.jpg": "9af5",
	"./theme_royalgold/images/login-left.jpg": "1c3f",
	"./theme_royalgold/images/login-left.png": "4548",
	"./theme_royalgold/images/login-logo-2-mb.jpg": "db99",
	"./theme_royalgold/images/login-logo.jpg": "d086",
	"./theme_royalgold/images/logo-2.webp": "1374",
	"./theme_royalgold/images/logo.png": "07b3",
	"./theme_royalgold/images/logo_ft.png": "e427",
	"./theme_royalgold/images/logo_katsuwin.png": "8721",
	"./theme_royalgold/images/lpfv-pc-2000.png": "9552",
	"./theme_royalgold/images/lpfv-pc-3000.png": "d4c8",
	"./theme_royalgold/images/lpfv-pc-4000.png": "f0d3",
	"./theme_royalgold/images/lpfv-pc-5000.png": "c85c",
	"./theme_royalgold/images/lpfv-pc.png": "cdbc",
	"./theme_royalgold/images/lpfv-sp-2000.png": "805d",
	"./theme_royalgold/images/lpfv-sp-3000.png": "0840",
	"./theme_royalgold/images/lpfv-sp-4000.png": "efa0",
	"./theme_royalgold/images/lpfv-sp-5000.png": "b3a6",
	"./theme_royalgold/images/lpfv-sp.png": "58d6",
	"./theme_royalgold/images/main_bg.jpg": "677b",
	"./theme_royalgold/images/mall-invite-image.png": "dba9",
	"./theme_royalgold/images/mall-product-image.png": "5c8c",
	"./theme_royalgold/images/money_pop.png": "b82b",
	"./theme_royalgold/images/monthly-bonus.png": "cbdb",
	"./theme_royalgold/images/monyback-gold.svg": "171b",
	"./theme_royalgold/images/monyback-icon.svg": "7834",
	"./theme_royalgold/images/my-account.png": "b9f1",
	"./theme_royalgold/images/my_kyc_ex1.png": "9ad2",
	"./theme_royalgold/images/my_kyc_ex2.webp": "56b9",
	"./theme_royalgold/images/nav-bottom-deposit-active.png": "dcc9",
	"./theme_royalgold/images/nav-bottom-deposit.png": "c16e",
	"./theme_royalgold/images/nav-bottom-game-active.png": "5877",
	"./theme_royalgold/images/nav-bottom-game.png": "0eeb",
	"./theme_royalgold/images/nav-bottom-home-active.png": "b9b1",
	"./theme_royalgold/images/nav-bottom-home-mobile-index.png": "4943",
	"./theme_royalgold/images/nav-bottom-home.png": "7402",
	"./theme_royalgold/images/nav-bottom-my-active.png": "6859",
	"./theme_royalgold/images/nav-bottom-my.png": "d08c",
	"./theme_royalgold/images/nav-bottom-offers-active.png": "1fee",
	"./theme_royalgold/images/nav-bottom-offers.png": "675a",
	"./theme_royalgold/images/nav-bottom-toggle.png": "6b35",
	"./theme_royalgold/images/new_guide.png": "c7c2",
	"./theme_royalgold/images/no-data.png": "0b29",
	"./theme_royalgold/images/no.svg": "37ba",
	"./theme_royalgold/images/oncasy_logo.png": "264d",
	"./theme_royalgold/images/pachislot.png": "dc2d",
	"./theme_royalgold/images/personal_data_ad.png": "6e3c",
	"./theme_royalgold/images/program.png": "b113",
	"./theme_royalgold/images/rank-1st.png": "42bf",
	"./theme_royalgold/images/rank-2nd.png": "901c",
	"./theme_royalgold/images/rank-3rd.png": "06bc",
	"./theme_royalgold/images/rebate-bonus.png": "198d",
	"./theme_royalgold/images/register-bg.jpg": "d02f",
	"./theme_royalgold/images/register-logo-pc.jpg": "7a4f",
	"./theme_royalgold/images/register-logo.jpg": "409a",
	"./theme_royalgold/images/register-logo.png": "b273",
	"./theme_royalgold/images/registration-2000.png": "bcb4",
	"./theme_royalgold/images/registration-3000.png": "04d8",
	"./theme_royalgold/images/registration-4000.png": "1143",
	"./theme_royalgold/images/registration-5000.png": "d096",
	"./theme_royalgold/images/registration.png": "2acc",
	"./theme_royalgold/images/shop.png": "9044",
	"./theme_royalgold/images/skill.png": "eba9",
	"./theme_royalgold/images/slots.png": "045b",
	"./theme_royalgold/images/spin_wheel_bg_lt.png": "f4e7",
	"./theme_royalgold/images/spin_wheel_bg_rt.png": "d1bb",
	"./theme_royalgold/images/stake-logo.png": "4452",
	"./theme_royalgold/images/structure01.png": "de4a",
	"./theme_royalgold/images/structure01.svg": "712e",
	"./theme_royalgold/images/structure02.png": "1be3",
	"./theme_royalgold/images/structure02.svg": "1519",
	"./theme_royalgold/images/structure03.png": "e8a3",
	"./theme_royalgold/images/structure03.svg": "5234",
	"./theme_royalgold/images/sup/pc_banner_sup_faq_k.webp": "cdb9",
	"./theme_royalgold/images/sup/sub_support_1.png": "5d51",
	"./theme_royalgold/images/sup/sub_support_2.png": "fb2c",
	"./theme_royalgold/images/sup/sub_support_3.png": "47df",
	"./theme_royalgold/images/sup/sub_support_4.png": "c751",
	"./theme_royalgold/images/sup/sub_support_5.png": "31d9",
	"./theme_royalgold/images/sup/sub_support_6.png": "1e057",
	"./theme_royalgold/images/sup/sub_support_7.png": "25b2",
	"./theme_royalgold/images/sup/sub_support_8.png": "3c66",
	"./theme_royalgold/images/sup/sub_support_9.png": "69d79",
	"./theme_royalgold/images/sup/sub_support_banner.png": "3773",
	"./theme_royalgold/images/sup/sup-self-restraint_banner.jpg": "76ce",
	"./theme_royalgold/images/sup/sup_cardsetting_bank1.jpg": "7429",
	"./theme_royalgold/images/sup/sup_cardsetting_bank2.jpg": "839c",
	"./theme_royalgold/images/sup/sup_cardsetting_bank3.jpg": "467a",
	"./theme_royalgold/images/sup/sup_cardsetting_bank4.jpg": "8f23",
	"./theme_royalgold/images/sup/sup_cardsetting_banner.jpg": "05e6",
	"./theme_royalgold/images/sup/sup_cardsetting_ewallet1.jpg": "760b",
	"./theme_royalgold/images/sup/sup_cardsetting_ewallet2.jpg": "1afa",
	"./theme_royalgold/images/sup/sup_cardsetting_ewallet3.jpg": "befa",
	"./theme_royalgold/images/sup/sup_cardsetting_ewallet4.jpg": "4d87",
	"./theme_royalgold/images/sup/sup_cardsetting_ewalleti2.jpg": "2a6d",
	"./theme_royalgold/images/sup/sup_cardsetting_ewalleti3.jpg": "12dc",
	"./theme_royalgold/images/sup/sup_cardsetting_ewalletid1.jpg": "37c25",
	"./theme_royalgold/images/sup/sup_cardsetting_ewalletid4.jpg": "3e80",
	"./theme_royalgold/images/sup/sup_cardsetting_ewalletid5.jpg": "c15e",
	"./theme_royalgold/images/sup/sup_deposit_bank1.jpg": "ec8e",
	"./theme_royalgold/images/sup/sup_deposit_bank2.jpg": "3e2b",
	"./theme_royalgold/images/sup/sup_deposit_bank3.jpg": "563c",
	"./theme_royalgold/images/sup/sup_deposit_bank_1.png": "39c3",
	"./theme_royalgold/images/sup/sup_deposit_bank_2.png": "2297",
	"./theme_royalgold/images/sup/sup_deposit_bank_3.png": "890f",
	"./theme_royalgold/images/sup/sup_deposit_bank_4.png": "7ba8",
	"./theme_royalgold/images/sup/sup_deposit_ccpayment1.jpg": "71b8",
	"./theme_royalgold/images/sup/sup_deposit_ccpayment2.jpg": "dbdd",
	"./theme_royalgold/images/sup/sup_deposit_ccpayment3.jpg": "0fed",
	"./theme_royalgold/images/sup/sup_deposit_crypto1.jpg": "8388",
	"./theme_royalgold/images/sup/sup_deposit_crypto10.jpg": "2b12",
	"./theme_royalgold/images/sup/sup_deposit_crypto11.jpg": "88b8",
	"./theme_royalgold/images/sup/sup_deposit_crypto12.jpg": "7463",
	"./theme_royalgold/images/sup/sup_deposit_crypto2.jpg": "60ec",
	"./theme_royalgold/images/sup/sup_deposit_crypto3.jpg": "0661",
	"./theme_royalgold/images/sup/sup_deposit_crypto4.jpg": "18cc",
	"./theme_royalgold/images/sup/sup_deposit_crypto5.jpg": "8f43",
	"./theme_royalgold/images/sup/sup_deposit_crypto6.jpg": "1fe6",
	"./theme_royalgold/images/sup/sup_deposit_crypto7.jpg": "086f",
	"./theme_royalgold/images/sup/sup_deposit_crypto8.jpg": "fa4b",
	"./theme_royalgold/images/sup/sup_deposit_crypto9.jpg": "220f",
	"./theme_royalgold/images/sup/sup_deposit_jeten1.jpg": "02be",
	"./theme_royalgold/images/sup/sup_deposit_jeten2.jpg": "9943",
	"./theme_royalgold/images/sup/sup_deposit_jeten3.jpg": "3637",
	"./theme_royalgold/images/sup/sup_deposit_mtpay1.jpg": "9f2f",
	"./theme_royalgold/images/sup/sup_deposit_mtpay2.jpg": "412c",
	"./theme_royalgold/images/sup/sup_deposit_mtpay3.jpg": "22bb",
	"./theme_royalgold/images/sup/sup_deposit_vega1.jpg": "a7bf",
	"./theme_royalgold/images/sup/sup_deposit_vega2.jpg": "ec34",
	"./theme_royalgold/images/sup/sup_deposit_vega3.jpg": "2d66",
	"./theme_royalgold/images/sup/sup_deposit_vega4.jpg": "a25b",
	"./theme_royalgold/images/sup/sup_faq_banner.jpg": "d370",
	"./theme_royalgold/images/sup/sup_kyc_1.jpg": "bd9d",
	"./theme_royalgold/images/sup/sup_kyc_10.jpg": "5597",
	"./theme_royalgold/images/sup/sup_kyc_11.jpg": "d4e2",
	"./theme_royalgold/images/sup/sup_kyc_2.jpg": "8000",
	"./theme_royalgold/images/sup/sup_kyc_3.jpg": "1227",
	"./theme_royalgold/images/sup/sup_kyc_4.jpg": "ee2f",
	"./theme_royalgold/images/sup/sup_kyc_5.jpg": "f055",
	"./theme_royalgold/images/sup/sup_kyc_6.jpg": "4299",
	"./theme_royalgold/images/sup/sup_kyc_7.jpg": "94d3",
	"./theme_royalgold/images/sup/sup_kyc_8.jpg": "5d50",
	"./theme_royalgold/images/sup/sup_kyc_9.jpg": "dbf4",
	"./theme_royalgold/images/sup/sup_kyc_banner.jpg": "9fe7",
	"./theme_royalgold/images/sup/sup_login_1.png": "1cf6",
	"./theme_royalgold/images/sup/sup_login_2.png": "3e13",
	"./theme_royalgold/images/sup/sup_login_3.png": "7c9a",
	"./theme_royalgold/images/sup/sup_login_4.png": "c79b",
	"./theme_royalgold/images/sup/sup_login_5.png": "9ed9",
	"./theme_royalgold/images/sup/sup_login_6.png": "666f",
	"./theme_royalgold/images/sup/sup_login_7.png": "60ac",
	"./theme_royalgold/images/sup/sup_login_banner.png": "8b16",
	"./theme_royalgold/images/sup/sup_payment_method_banner.jpg": "8a9a",
	"./theme_royalgold/images/sup/sup_register_1.png": "908d",
	"./theme_royalgold/images/sup/sup_register_2.png": "4ff0",
	"./theme_royalgold/images/sup/sup_register_3.png": "ff44",
	"./theme_royalgold/images/sup/sup_register_4.png": "377e",
	"./theme_royalgold/images/sup/sup_register_5.png": "66d1",
	"./theme_royalgold/images/sup/sup_register_banner.png": "29e5",
	"./theme_royalgold/images/sup/sup_vip_class_upgrading1.jpg": "aefb",
	"./theme_royalgold/images/sup/sup_vip_class_upgrading2.jpg": "457a",
	"./theme_royalgold/images/sup/sup_vip_class_upgrading3.jpg": "3ed5",
	"./theme_royalgold/images/sup/sup_vip_class_upgrading4.jpg": "d04a",
	"./theme_royalgold/images/sup/sup_vip_class_upgrading_banner.jpg": "69df",
	"./theme_royalgold/images/sup/sup_wallet_1.jpg": "1549",
	"./theme_royalgold/images/sup/sup_wallet_2.jpg": "03a8",
	"./theme_royalgold/images/sup/sup_wallet_3.jpg": "1882",
	"./theme_royalgold/images/sup/sup_wallet_4.jpg": "9daa",
	"./theme_royalgold/images/sup/sup_wallet_5.jpg": "00b5",
	"./theme_royalgold/images/sup/sup_wallet_6.jpg": "9578",
	"./theme_royalgold/images/sup/sup_wallet_banner.jpg": "87fa",
	"./theme_royalgold/images/sup/sup_withdraw_bank1.jpg": "9fd8",
	"./theme_royalgold/images/sup/sup_withdraw_bank2.jpg": "30f6",
	"./theme_royalgold/images/sup/sup_withdraw_bank3.jpg": "a26c",
	"./theme_royalgold/images/sup/sup_withdraw_crypto1.jpg": "8c98",
	"./theme_royalgold/images/sup/sup_withdraw_crypto2.jpg": "cc652",
	"./theme_royalgold/images/sup/sup_withdraw_crypto3.jpg": "c93d",
	"./theme_royalgold/images/sup/sup_withdraw_crypto4.jpg": "81c3",
	"./theme_royalgold/images/sup/sup_withdraw_jeton1.jpg": "b690",
	"./theme_royalgold/images/sup/sup_withdraw_jeton2.jpg": "1476",
	"./theme_royalgold/images/sup/sup_withdraw_jeton3.jpg": "a593",
	"./theme_royalgold/images/sup/sup_withdraw_mtpay1.jpg": "9a8f",
	"./theme_royalgold/images/sup/sup_withdraw_mtpay2.jpg": "3244",
	"./theme_royalgold/images/sup/sup_withdraw_mtpay3.jpg": "fedc",
	"./theme_royalgold/images/sup/sup_withdraw_vega1.jpg": "0767",
	"./theme_royalgold/images/sup/sup_withdraw_vega2.jpg": "343c",
	"./theme_royalgold/images/sup/sup_withdraw_vega3.jpg": "ad45",
	"./theme_royalgold/images/terms-bg.png": "6785",
	"./theme_royalgold/images/title-championship.png": "fb09",
	"./theme_royalgold/images/top10-bn.png": "7d2a",
	"./theme_royalgold/images/top10-bn2.png": "4f80",
	"./theme_royalgold/images/top_up.png": "cbad",
	"./theme_royalgold/images/trophy-gold.svg": "505f",
	"./theme_royalgold/images/trophy-icon.svg": "f438",
	"./theme_royalgold/images/useful_link/agent_five.webp": "a522",
	"./theme_royalgold/images/useful_link/agent_four.webp": "0c44",
	"./theme_royalgold/images/useful_link/agent_one.webp": "6931",
	"./theme_royalgold/images/useful_link/agent_three.webp": "6e6b",
	"./theme_royalgold/images/useful_link/agent_two.webp": "8b1a",
	"./theme_royalgold/images/useful_link/agent_validSeal.webp": "1bfc",
	"./theme_royalgold/images/useful_link/bg.jpg": "63b6",
	"./theme_royalgold/images/useful_link/bonusIntroducing.webp": "d72f",
	"./theme_royalgold/images/useful_link/icon_FAQ.png": "f495",
	"./theme_royalgold/images/useful_link/icon_account_binding.png": "2e16",
	"./theme_royalgold/images/useful_link/icon_confirm_method.png": "9aaa",
	"./theme_royalgold/images/useful_link/icon_coupon.png": "6ec6",
	"./theme_royalgold/images/useful_link/icon_deposit_withdraw.png": "1728",
	"./theme_royalgold/images/useful_link/icon_event_bonus.png": "bbc6",
	"./theme_royalgold/images/useful_link/icon_login.png": "c274",
	"./theme_royalgold/images/useful_link/icon_login_method.png": "7c23",
	"./theme_royalgold/images/useful_link/icon_recommended_games.png": "826a",
	"./theme_royalgold/images/useful_link/icon_self_restriction.png": "43a4",
	"./theme_royalgold/images/useful_link/icon_shop.png": "638b",
	"./theme_royalgold/images/useful_link/icon_vip_class_upgrading.png": "ceeb4",
	"./theme_royalgold/images/useful_link/icon_wallet.png": "d4b1",
	"./theme_royalgold/images/useful_link/pc_banner_agent.jpeg": "6dc2",
	"./theme_royalgold/images/useful_link/pc_banner_cookie.jpeg": "4b1f",
	"./theme_royalgold/images/useful_link/pc_banner_cooperation.jpeg": "5564",
	"./theme_royalgold/images/useful_link/pc_banner_cooperation.jpg": "f032",
	"./theme_royalgold/images/useful_link/pc_banner_privacy.jpeg": "38d4",
	"./theme_royalgold/images/useful_link/pc_banner_rule.jpeg": "0964",
	"./theme_royalgold/images/useful_link/pc_banner_sport.jpeg": "14a6",
	"./theme_royalgold/images/useful_link/pc_banner_support.jpeg": "305c",
	"./theme_royalgold/images/useful_link/pc_banner_support.png": "0ceb",
	"./theme_royalgold/images/useful_link/pc_banner_terms.png": "2512",
	"./theme_royalgold/images/vector.svg": "88b83",
	"./theme_royalgold/images/verify.png": "c35a",
	"./theme_royalgold/images/vip-24-hours.png": "74ed",
	"./theme_royalgold/images/vip-arrow-left.png": "635a",
	"./theme_royalgold/images/vip-arrow-right.png": "d8b1",
	"./theme_royalgold/images/vip-bg.jpg": "2b5d",
	"./theme_royalgold/images/vip-bonus.png": "9727",
	"./theme_royalgold/images/vip-coin-stack.png": "7e19",
	"./theme_royalgold/images/vip-crown.png": "f0ba",
	"./theme_royalgold/images/vip-green-line.png": "c467",
	"./theme_royalgold/images/vip-roulette.png": "bc46",
	"./theme_royalgold/images/vip-wallet.png": "0878",
	"./theme_royalgold/images/vip.png": "7056",
	"./theme_royalgold/images/vip_bg.jpg": "19c9",
	"./theme_royalgold/images/vip_bg.png": "1473",
	"./theme_royalgold/images/vip_gift_bg.png": "c0df",
	"./theme_royalgold/images/wallet.png": "cbca",
	"./theme_royalgold/images/web_TOP.png": "42a9",
	"./theme_royalgold/images/weekly-bonus.png": "705e",
	"./theme_royalgold/images/wheel_2x.png": "41cd",
	"./theme_royalgold/variables.css": "3610"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";